export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		randomBattleMoves: ["gigadrain", "leechseed", "sleeppowder", "sludgebomb", "substitute"],
		randomDoubleBattleMoves: ["gigadrain", "hiddenpowerfire", "hiddenpowerice", "powerwhip", "protect", "sleeppowder", "sludgebomb"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	venusaurmega: {
		randomBattleMoves: ["earthquake", "gigadrain", "hiddenpowerfire", "leechseed", "sludgebomb", "synthesis"],
		randomDoubleBattleMoves: ["gigadrain", "hiddenpowerfire", "hiddenpowerice", "powerwhip", "protect", "sleeppowder", "sludgebomb"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		randomBattleMoves: ["airslash", "earthquake", "fireblast", "holdhands", "roost"],
		randomDoubleBattleMoves: ["airslash", "fireblast", "focusblast", "heatwave", "holdhands", "protect", "roost"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	charizardmegax: {
		randomBattleMoves: ["dragonclaw", "dragondance", "earthquake", "flareblitz", "roost", "willowisp"],
		randomDoubleBattleMoves: ["dragonclaw", "dragondance", "flareblitz", "rockslide", "roost", "thunderpunch"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	charizardmegay: {
		randomBattleMoves: ["airslash", "dragonpulse", "fireblast", "focusblast", "roost", "solarbeam"],
		randomDoubleBattleMoves: ["airslash", "fireblast", "focusblast", "heatwave", "protect", "solarbeam"],
		tier: "OU",
		doublesTier: "DOU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		randomBattleMoves: ["dragontail", "icebeam", "rapidspin", "roar", "scald", "toxic"],
		randomDoubleBattleMoves: ["fakeout", "followme", "icywind", "muddywater", "protect", "rapidspin", "scald"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	blastoisemega: {
		randomBattleMoves: ["aurasphere", "darkpulse", "icebeam", "rapidspin", "waterpulse"],
		randomDoubleBattleMoves: ["aurasphere", "darkpulse", "fakeout", "icebeam", "muddywater", "protect", "waterpulse"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		randomBattleMoves: ["airslash", "bugbuzz", "energyball", "quiverdance", "sleeppowder"],
		randomDoubleBattleMoves: ["airslash", "bugbuzz", "protect", "quiverdance", "sleeppowder"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		randomBattleMoves: ["endeavor", "knockoff", "poisonjab", "tailwind", "toxicspikes", "uturn"],
		randomDoubleBattleMoves: ["knockoff", "poisonjab", "protect", "tailwind", "toxicspikes", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	beedrillmega: {
		randomBattleMoves: ["drillrun", "knockoff", "poisonjab", "swordsdance", "uturn", "xscissor"],
		randomDoubleBattleMoves: ["drillrun", "knockoff", "poisonjab", "protect", "uturn", "xscissor"],
		tier: "UU",
		doublesTier: "DUU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		randomBattleMoves: ["bravebird", "defog", "heatwave", "return", "roost", "uturn"],
		randomDoubleBattleMoves: ["bravebird", "doubleedge", "heatwave", "protect", "return", "tailwind", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pidgeotmega: {
		randomBattleMoves: ["defog", "heatwave", "hurricane", "roost", "uturn"],
		randomDoubleBattleMoves: ["heatwave", "hurricane", "protect", "tailwind", "uturn"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	rattata: {
		tier: "LC",
	},
	rattataalola: {
		tier: "LC",
	},
	raticate: {
		randomBattleMoves: ["facade", "protect", "stompingtantrum", "suckerpunch", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["crunch", "facade", "protect", "stompingtantrum", "suckerpunch", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	raticatealola: {
		randomBattleMoves: ["doubleedge", "knockoff", "return", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["doubleedge", "knockoff", "protect", "suckerpunch", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	raticatealolatotem: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		randomBattleMoves: ["doubleedge", "drillpeck", "drillrun", "pursuit", "return", "uturn"],
		randomDoubleBattleMoves: ["doubleedge", "drillpeck", "drillrun", "protect", "quickattack", "return", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		randomBattleMoves: ["aquatail", "coil", "earthquake", "gunkshot", "rest", "suckerpunch"],
		randomDoubleBattleMoves: ["aquatail", "coil", "gunkshot", "protect", "stompingtantrum", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pichu: {
		tier: "LC",
	},
	pikachu: {
		randomBattleMoves: ["extremespeed", "grassknot", "hiddenpowerice", "irontail", "knockoff", "voltswitch", "volttackle"],
		randomDoubleBattleMoves: ["encore", "fakeout", "grassknot", "hiddenpowerice", "knockoff", "protect", "voltswitch", "volttackle"],
		tier: "NFE",
	},
	pikachuoriginal: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachuhoenn: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachusinnoh: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachuunova: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachukalos: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachualola: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachupartner: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	raichu: {
		randomBattleMoves: ["encore", "focusblast", "grassknot", "hiddenpowerice", "nastyplot", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["encore", "fakeout", "focusblast", "grassknot", "hiddenpowerice", "protect", "thunderbolt", "voltswitch"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	raichualola: {
		randomBattleMoves: ["focusblast", "nastyplot", "psyshock", "surf", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["fakeout", "grassknot", "nastyplot", "protect", "psyshock", "thunderbolt", "voltswitch"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	sandshrew: {
		tier: "LC",
	},
	sandshrewalola: {
		tier: "LC",
	},
	sandslash: {
		randomBattleMoves: ["earthquake", "knockoff", "rapidspin", "stealthrock", "stoneedge", "swordsdance", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "knockoff", "protect", "stealthrock", "stoneedge", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	sandslashalola: {
		randomBattleMoves: ["earthquake", "iciclecrash", "ironhead", "knockoff", "rapidspin", "stealthrock", "swordsdance"],
		randomDoubleBattleMoves: ["drillrun", "iciclecrash", "ironhead", "protect", "swordsdance"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		randomBattleMoves: ["earthpower", "fireblast", "icebeam", "sludgewave", "stealthrock", "toxicspikes"],
		randomDoubleBattleMoves: ["earthpower", "icebeam", "protect", "sludgebomb", "stealthrock"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		randomBattleMoves: ["earthpower", "fireblast", "icebeam", "sludgewave", "substitute", "superpower"],
		randomDoubleBattleMoves: ["earthpower", "fireblast", "icebeam", "protect", "sludgebomb"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "PU",
		doublesTier: "NFE",
	},
	clefable: {
		randomBattleMoves: ["calmmind", "fireblast", "moonblast", "softboiled", "stealthrock", "thunderwave"],
		randomDoubleBattleMoves: ["dazzlinggleam", "fireblast", "followme", "helpinghand", "moonblast", "protect", "softboiled", "thunderwave"],
		tier: "OU",
		doublesTier: "DUU",
	},
	vulpix: {
		tier: "NFE",
	},
	vulpixalola: {
		tier: "LC",
	},
	ninetales: {
		randomBattleMoves: ["fireblast", "nastyplot", "psyshock", "solarbeam", "substitute", "willowisp"],
		randomDoubleBattleMoves: ["fireblast", "heatwave", "nastyplot", "protect", "solarbeam", "willowisp"],
		tier: "RU",
		doublesTier: "DUU",
	},
	ninetalesalola: {
		randomBattleMoves: ["auroraveil", "blizzard", "freezedry", "hiddenpowerfire", "moonblast", "nastyplot", "substitute"],
		randomDoubleBattleMoves: ["auroraveil", "blizzard", "encore", "freezedry", "hiddenpowerfire", "moonblast", "protect"],
		tier: "UUBL",
		doublesTier: "DOU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		randomBattleMoves: ["dazzlinggleam", "fireblast", "healbell", "lightscreen", "reflect", "stealthrock"],
		randomDoubleBattleMoves: ["dazzlinggleam", "fireblast", "hypervoice", "protect", "stealthrock", "thunderwave"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NU",
		doublesTier: "NFE",
	},
	crobat: {
		randomBattleMoves: ["bravebird", "defog", "roost", "superfang", "taunt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["bravebird", "protect", "superfang", "tailwind", "taunt", "uturn"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		randomBattleMoves: ["aromatherapy", "gigadrain", "hiddenpowerfire", "sleeppowder", "sludgebomb", "strengthsap"],
		randomDoubleBattleMoves: ["energyball", "hiddenpowerfire", "protect", "sleeppowder", "sludgebomb", "strengthsap"],
		tier: "NUBL",
		doublesTier: "(DUU)",
	},
	bellossom: {
		randomBattleMoves: ["gigadrain", "hiddenpowerground", "moonblast", "quiverdance", "sleeppowder", "strengthsap"],
		randomDoubleBattleMoves: ["energyball", "moonblast", "quiverdance", "sleeppowder", "strengthsap"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		randomBattleMoves: ["knockoff", "leechlife", "leechseed", "seedbomb", "spore", "substitute"],
		randomDoubleBattleMoves: ["knockoff", "leechlife", "leechseed", "protect", "ragepowder", "seedbomb", "spore", "wideguard"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		randomBattleMoves: ["bugbuzz", "quiverdance", "sleeppowder", "sludgebomb", "substitute"],
		randomDoubleBattleMoves: ["bugbuzz", "protect", "quiverdance", "ragepowder", "sleeppowder", "sludgebomb"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	diglett: {
		tier: "LC",
	},
	diglettalola: {
		tier: "LC",
	},
	dugtrio: {
		randomBattleMoves: ["earthquake", "reversal", "stealthrock", "stoneedge", "substitute", "suckerpunch"],
		randomDoubleBattleMoves: ["earthquake", "protect", "rockslide", "stoneedge", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	dugtrioalola: {
		randomBattleMoves: ["earthquake", "ironhead", "stealthrock", "stoneedge", "substitute", "suckerpunch", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "ironhead", "protect", "rockslide", "stoneedge", "suckerpunch"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	meowth: {
		tier: "LC",
	},
	meowthalola: {
		tier: "LC",
	},
	persian: {
		randomBattleMoves: ["fakeout", "knockoff", "return", "taunt", "uturn"],
		randomDoubleBattleMoves: ["fakeout", "hypnosis", "knockoff", "protect", "return", "taunt", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	persianalola: {
		randomBattleMoves: ["darkpulse", "hypnosis", "nastyplot", "powergem", "thunderbolt"],
		randomDoubleBattleMoves: ["fakeout", "foulplay", "hiddenpowerfighting", "icywind", "partingshot", "protect", "snarl"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		randomBattleMoves: ["calmmind", "encore", "hydropump", "icebeam", "psyshock", "scald", "substitute"],
		randomDoubleBattleMoves: ["calmmind", "encore", "focusblast", "hydropump", "icebeam", "protect", "scald"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		randomBattleMoves: ["closecombat", "earthquake", "gunkshot", "icepunch", "stoneedge", "uturn"],
		randomDoubleBattleMoves: ["closecombat", "icepunch", "poisonjab", "protect", "rockslide", "stompingtantrum", "stoneedge", "taunt", "uturn"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		randomBattleMoves: ["closecombat", "extremespeed", "flareblitz", "morningsun", "roar", "toxic", "wildcharge", "willowisp"],
		randomDoubleBattleMoves: ["closecombat", "extremespeed", "flareblitz", "protect", "snarl", "wildcharge", "willowisp"],
		tier: "RU",
		doublesTier: "DUU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		randomBattleMoves: ["circlethrow", "focusblast", "hydropump", "icepunch", "raindance", "rest", "scald", "sleeptalk"],
		randomDoubleBattleMoves: ["circlethrow", "encore", "icywind", "protect", "scald", "superpower", "toxic"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	politoed: {
		randomBattleMoves: ["encore", "icebeam", "protect", "rest", "scald", "toxic"],
		randomDoubleBattleMoves: ["encore", "helpinghand", "hypnosis", "icywind", "protect", "scald"],
		tier: "(PU)",
		doublesTier: "DOU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "NFE",
	},
	alakazam: {
		randomBattleMoves: ["focusblast", "hiddenpowerfire", "psychic", "psyshock", "shadowball"],
		randomDoubleBattleMoves: ["dazzlinggleam", "encore", "focusblast", "protect", "psychic", "shadowball"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	alakazammega: {
		randomBattleMoves: ["calmmind", "encore", "focusblast", "psyshock", "shadowball", "substitute"],
		randomDoubleBattleMoves: ["calmmind", "encore", "focusblast", "protect", "psychic", "shadowball"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NFE",
	},
	machamp: {
		randomBattleMoves: ["bulletpunch", "closecombat", "dynamicpunch", "facade", "knockoff", "stoneedge"],
		randomDoubleBattleMoves: ["bulletpunch", "closecombat", "facade", "knockoff", "protect", "stoneedge", "wideguard"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		randomBattleMoves: ["hiddenpowerfire", "poisonjab", "powerwhip", "sleeppowder", "sludgebomb", "strengthsap", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["growth", "knockoff", "powerwhip", "protect", "sleeppowder", "sludgebomb", "solarbeam", "suckerpunch", "sunnyday", "weatherball"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		randomBattleMoves: ["acidspray", "knockoff", "rapidspin", "scald", "sludgebomb", "toxicspikes"],
		randomDoubleBattleMoves: ["acidspray", "knockoff", "muddywater", "protect", "rapidspin", "scald", "sludgebomb"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	geodude: {
		tier: "LC",
	},
	geodudealola: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	graveleralola: {
		tier: "NFE",
	},
	golem: {
		randomBattleMoves: ["earthquake", "explosion", "rockblast", "stealthrock", "suckerpunch", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "protect", "rockslide", "stealthrock", "stoneedge", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	golemalola: {
		randomBattleMoves: ["earthquake", "firepunch", "stealthrock", "stoneedge", "wildcharge"],
		randomDoubleBattleMoves: ["doubleedge", "protect", "rockslide", "stealthrock", "stompingtantrum", "stoneedge"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		randomBattleMoves: ["flareblitz", "highhorsepower", "morningsun", "wildcharge", "willowisp"],
		randomDoubleBattleMoves: ["flareblitz", "highhorsepower", "hypnosis", "protect", "wildcharge", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		randomBattleMoves: ["fireblast", "icebeam", "psyshock", "scald", "slackoff", "thunderwave", "toxic"],
		randomDoubleBattleMoves: ["protect", "psychic", "psyshock", "scald", "slackoff", "thunderwave", "toxic"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	slowbromega: {
		randomBattleMoves: ["calmmind", "fireblast", "psyshock", "scald", "slackoff"],
		randomDoubleBattleMoves: ["fireblast", "icebeam", "protect", "psychic", "psyshock", "scald", "slackoff", "trickroom"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	slowking: {
		randomBattleMoves: ["dragontail", "fireblast", "icebeam", "nastyplot", "psyshock", "scald", "slackoff", "thunderwave", "toxic", "trickroom"],
		randomDoubleBattleMoves: ["fireblast", "protect", "psychic", "psyshock", "scald", "trickroom"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "UU",
		doublesTier: "NFE",
	},
	magnezone: {
		randomBattleMoves: ["flashcannon", "hiddenpowerfire", "substitute", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["electroweb", "flashcannon", "hiddenpowerfire", "protect", "thunderbolt", "voltswitch"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	farfetchd: {
		randomBattleMoves: ["bravebird", "knockoff", "leafblade", "return", "swordsdance"],
		randomDoubleBattleMoves: ["bravebird", "knockoff", "leafblade", "protect", "return", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		randomBattleMoves: ["bravebird", "jumpkick", "knockoff", "quickattack", "return", "swordsdance"],
		randomDoubleBattleMoves: ["bravebird", "knockoff", "protect", "quickattack", "return", "swordsdance"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		randomBattleMoves: ["encore", "icebeam", "perishsong", "protect", "surf", "toxic"],
		randomDoubleBattleMoves: ["encore", "fakeout", "helpinghand", "icebeam", "icywind", "liquidation", "protect", "toxic"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	grimer: {
		tier: "LC",
	},
	grimeralola: {
		tier: "LC",
	},
	muk: {
		randomBattleMoves: ["curse", "firepunch", "gunkshot", "icepunch", "memento", "poisonjab", "shadowsneak"],
		randomDoubleBattleMoves: ["firepunch", "gunkshot", "icepunch", "poisonjab", "protect", "shadowsneak"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mukalola: {
		randomBattleMoves: ["curse", "firepunch", "gunkshot", "icepunch", "knockoff", "poisonjab", "pursuit", "shadowsneak"],
		randomDoubleBattleMoves: ["gunkshot", "knockoff", "poisonjab", "protect", "shadowsneak", "snarl", "stoneedge"],
		tier: "UU",
		doublesTier: "DUU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		randomBattleMoves: ["hydropump", "iciclespear", "rapidspin", "rockblast", "shellsmash", "spikes"],
		randomDoubleBattleMoves: ["hydropump", "iciclespear", "protect", "rockblast", "shellsmash"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "PU",
		doublesTier: "NFE",
	},
	gengar: {
		randomBattleMoves: ["disable", "focusblast", "painsplit", "shadowball", "sludgewave", "substitute", "willowisp"],
		randomDoubleBattleMoves: ["focusblast", "protect", "shadowball", "sludgebomb", "taunt", "willowisp"],
		tier: "UU",
		doublesTier: "DUU",
	},
	gengarmega: {
		randomBattleMoves: ["destinybond", "disable", "focusblast", "perishsong", "protect", "shadowball", "sludgewave", "taunt"],
		randomDoubleBattleMoves: ["disable", "focusblast", "hypnosis", "protect", "shadowball", "sludgebomb", "willowisp"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		randomBattleMoves: ["earthquake", "ironhead", "roar", "rockslide", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "headsmash", "heavyslam", "protect", "stealthrock", "wideguard"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	steelixmega: {
		randomBattleMoves: ["dragontail", "earthquake", "heavyslam", "roar", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "heavyslam", "protect", "rockslide", "stealthrock"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		randomBattleMoves: ["foulplay", "protect", "psychic", "seismictoss", "thunderwave", "toxic", "wish"],
		randomDoubleBattleMoves: ["hypnosis", "protect", "psychic", "seismictoss", "thunderwave"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		randomBattleMoves: ["agility", "knockoff", "liquidation", "rockslide", "superpower", "swordsdance", "xscissor"],
		randomDoubleBattleMoves: ["agility", "knockoff", "liquidation", "protect", "rockslide", "wideguard", "xscissor"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		randomBattleMoves: ["foulplay", "hiddenpowergrass", "hiddenpowerice", "signalbeam", "taunt", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["foulplay", "protect", "taunt", "thunderbolt", "thunderwave", "voltswitch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "leechseed", "psychic", "sleeppowder", "substitute"],
		randomDoubleBattleMoves: ["energyball", "hiddenpowerfire", "leechseed", "protect", "psychic", "sleeppowder", "substitute", "trickroom"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	exeggutoralola: {
		randomBattleMoves: ["dracometeor", "flamethrower", "gigadrain", "leafstorm", "trickroom"],
		randomDoubleBattleMoves: ["dracometeor", "dragonhammer", "flamethrower", "leafstorm", "protect", "trickroom", "woodhammer"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		randomBattleMoves: ["bonemerang", "doubleedge", "earthquake", "knockoff", "stealthrock", "stoneedge", "substitute"],
		randomDoubleBattleMoves: ["bonemerang", "doubleedge", "firepunch", "protect", "rockslide", "stealthrock", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	marowakalola: {
		randomBattleMoves: ["bonemerang", "flamecharge", "flareblitz", "shadowbone", "stoneedge", "substitute", "willowisp"],
		randomDoubleBattleMoves: ["bonemerang", "flareblitz", "protect", "shadowbone", "stoneedge", "willowisp"],
		tier: "RU",
		doublesTier: "DUU",
	},
	marowakalolatotem: {
		tier: "RU",
		doublesTier: "DUU",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		randomBattleMoves: ["highjumpkick", "knockoff", "machpunch", "poisonjab", "rapidspin", "stoneedge"],
		randomDoubleBattleMoves: ["closecombat", "fakeout", "knockoff", "machpunch", "protect", "rockslide"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	hitmonchan: {
		randomBattleMoves: ["bulkup", "drainpunch", "icepunch", "machpunch", "rapidspin", "stoneedge"],
		randomDoubleBattleMoves: ["drainpunch", "fakeout", "firepunch", "icepunch", "machpunch", "protect"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	hitmontop: {
		randomBattleMoves: ["closecombat", "rapidspin", "stoneedge", "suckerpunch", "toxic"],
		randomDoubleBattleMoves: ["closecombat", "fakeout", "feint", "helpinghand", "machpunch", "rapidspin", "suckerpunch", "wideguard"],
		tier: "NU",
		doublesTier: "DUU",
	},
	lickitung: {
		tier: "LC",
	},
	lickilicky: {
		randomBattleMoves: ["bodyslam", "dragontail", "earthquake", "explosion", "healbell", "knockoff", "powerwhip", "protect", "swordsdance", "wish"],
		randomDoubleBattleMoves: ["bodyslam", "dragontail", "explosion", "knockoff", "powerwhip", "protect", "stompingtantrum"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		randomBattleMoves: ["fireblast", "painsplit", "protect", "sludgebomb", "toxicspikes", "willowisp"],
		randomDoubleBattleMoves: ["fireblast", "painsplit", "protect", "sludgebomb", "toxicspikes", "willowisp"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		randomBattleMoves: ["earthquake", "megahorn", "stealthrock", "stoneedge", "toxic"],
		tier: "NU",
		doublesTier: "NFE",
	},
	rhyperior: {
		randomBattleMoves: ["dragontail", "earthquake", "icepunch", "megahorn", "rockpolish", "stoneedge"],
		randomDoubleBattleMoves: ["earthquake", "icepunch", "megahorn", "protect", "rockslide", "stealthrock", "stoneedge"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		randomBattleMoves: ["healbell", "seismictoss", "softboiled", "stealthrock", "thunderwave", "toxic", "wish"],
		randomDoubleBattleMoves: ["helpinghand", "protect", "seismictoss", "softboiled", "thunderwave", "toxic"],
		tier: "OU",
		doublesTier: "NFE",
	},
	blissey: {
		randomBattleMoves: ["healbell", "seismictoss", "softboiled", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["helpinghand", "protect", "seismictoss", "softboiled", "thunderwave", "toxic"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	tangela: {
		tier: "PU",
		doublesTier: "NFE",
	},
	tangrowth: {
		randomBattleMoves: ["earthquake", "gigadrain", "hiddenpowerfire", "knockoff", "leafstorm", "rockslide", "sleeppowder", "synthesis"],
		randomDoubleBattleMoves: ["earthquake", "focusblast", "gigadrain", "hiddenpowerice", "knockoff", "leechseed", "powerwhip", "protect", "ragepowder", "sleeppowder"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	kangaskhan: {
		randomBattleMoves: ["crunch", "drainpunch", "earthquake", "fakeout", "return", "suckerpunch"],
		randomDoubleBattleMoves: ["crunch", "doubleedge", "drainpunch", "earthquake", "fakeout", "protect", "return", "suckerpunch"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	kangaskhanmega: {
		randomBattleMoves: ["bodyslam", "crunch", "fakeout", "seismictoss", "suckerpunch"],
		randomDoubleBattleMoves: ["drainpunch", "earthquake", "fakeout", "poweruppunch", "protect", "return", "suckerpunch"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		randomBattleMoves: ["dracometeor", "hydropump", "icebeam", "raindance", "waterfall"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "hydropump", "icebeam", "muddywater", "protect", "raindance"],
		tier: "NUBL",
		doublesTier: "DOU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		randomBattleMoves: ["drillrun", "icebeam", "knockoff", "megahorn", "raindance", "waterfall"],
		randomDoubleBattleMoves: ["drillrun", "icywind", "knockoff", "megahorn", "protect", "waterfall"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		randomBattleMoves: ["hydropump", "icebeam", "psyshock", "rapidspin", "recover", "scald", "thunderbolt"],
		randomDoubleBattleMoves: ["hydropump", "icebeam", "protect", "psychic", "psyshock", "scald", "thunderbolt"],
		tier: "UU",
		doublesTier: "DUU",
	},
	mimejr: {
		tier: "LC",
	},
	mrmime: {
		randomBattleMoves: ["dazzlinggleam", "encore", "focusblast", "healingwish", "nastyplot", "psyshock", "shadowball"],
		randomDoubleBattleMoves: ["dazzlinggleam", "encore", "fakeout", "followme", "hiddenpowerfighting", "icywind", "protect", "psychic", "thunderbolt", "thunderwave", "wideguard"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	scyther: {
		randomBattleMoves: ["aerialace", "brickbreak", "bugbite", "knockoff", "roost", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["aerialace", "brickbreak", "bugbite", "feint", "knockoff", "protect", "swordsdance", "uturn"],
		tier: "PU",
		doublesTier: "NFE",
	},
	scizor: {
		randomBattleMoves: ["bugbite", "bulletpunch", "knockoff", "pursuit", "superpower", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["bugbite", "bulletpunch", "feint", "knockoff", "protect", "superpower", "swordsdance", "uturn"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	scizormega: {
		randomBattleMoves: ["bugbite", "bulletpunch", "defog", "knockoff", "roost", "superpower", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["bugbite", "bulletpunch", "feint", "knockoff", "protect", "roost", "superpower", "swordsdance", "uturn"],
		tier: "OU",
		doublesTier: "DUU",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		randomBattleMoves: ["focusblast", "icebeam", "lovelykiss", "nastyplot", "psychic", "psyshock", "substitute", "trick"],
		randomDoubleBattleMoves: ["focusblast", "icebeam", "lovelykiss", "nastyplot", "protect", "psychic", "psyshock"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "NFE",
	},
	electivire: {
		randomBattleMoves: ["crosschop", "earthquake", "flamethrower", "icepunch", "voltswitch", "wildcharge"],
		randomDoubleBattleMoves: ["crosschop", "flamethrower", "followme", "icepunch", "protect", "stompingtantrum", "wildcharge"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		tier: "NFE",
	},
	magmortar: {
		randomBattleMoves: ["earthquake", "fireblast", "focusblast", "hiddenpowergrass", "hiddenpowerice", "substitute", "thunderbolt"],
		randomDoubleBattleMoves: ["fireblast", "followme", "heatwave", "hiddenpowergrass", "hiddenpowerice", "protect", "taunt", "thunderbolt", "willowisp"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	pinsir: {
		randomBattleMoves: ["closecombat", "earthquake", "knockoff", "stealthrock", "stoneedge", "xscissor"],
		randomDoubleBattleMoves: ["closecombat", "feint", "knockoff", "protect", "rockslide", "xscissor"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pinsirmega: {
		randomBattleMoves: ["closecombat", "earthquake", "quickattack", "return", "swordsdance"],
		randomDoubleBattleMoves: ["closecombat", "feint", "protect", "quickattack", "return", "rockslide", "swordsdance"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	tauros: {
		randomBattleMoves: ["bodyslam", "doubleedge", "earthquake", "rockslide", "zenheadbutt"],
		randomDoubleBattleMoves: ["doubleedge", "protect", "return", "rockslide", "stompingtantrum", "stoneedge", "zenheadbutt"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		randomBattleMoves: ["bounce", "dragondance", "earthquake", "stoneedge", "substitute", "waterfall"],
		randomDoubleBattleMoves: ["bounce", "dragondance", "protect", "stoneedge", "thunderwave", "waterfall"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	gyaradosmega: {
		randomBattleMoves: ["crunch", "dragondance", "earthquake", "icefang", "substitute", "waterfall"],
		randomDoubleBattleMoves: ["crunch", "dragondance", "icefang", "protect", "taunt", "thunderwave", "waterfall"],
		tier: "OU",
		doublesTier: "DUU",
	},
	lapras: {
		randomBattleMoves: ["freezedry", "healbell", "hydropump", "icebeam", "protect", "thunderbolt", "toxic"],
		randomDoubleBattleMoves: ["freezedry", "helpinghand", "hydropump", "iceshard", "icywind", "protect"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	ditto: {
		randomBattleMoves: ["transform"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		randomBattleMoves: ["icebeam", "protect", "roar", "scald", "toxic", "wish"],
		randomDoubleBattleMoves: ["helpinghand", "icywind", "muddywater", "protect", "scald", "toxic"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	jolteon: {
		randomBattleMoves: ["hiddenpowerice", "shadowball", "signalbeam", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["helpinghand", "hiddenpowergrass", "hiddenpowerice", "protect", "signalbeam", "thunderbolt", "voltswitch"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	flareon: {
		randomBattleMoves: ["facade", "flamecharge", "flareblitz", "quickattack", "superpower"],
		randomDoubleBattleMoves: ["facade", "flamecharge", "flareblitz", "protect", "superpower"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	espeon: {
		randomBattleMoves: ["calmmind", "dazzlinggleam", "morningsun", "psychic", "psyshock", "shadowball"],
		randomDoubleBattleMoves: ["calmmind", "dazzlinggleam", "helpinghand", "protect", "psychic", "shadowball"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	umbreon: {
		randomBattleMoves: ["foulplay", "protect", "toxic", "wish"],
		randomDoubleBattleMoves: ["foulplay", "helpinghand", "moonlight", "protect", "snarl"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	leafeon: {
		randomBattleMoves: ["healbell", "knockoff", "leafblade", "swordsdance", "synthesis", "xscissor"],
		randomDoubleBattleMoves: ["helpinghand", "knockoff", "leafblade", "protect", "swordsdance", "xscissor"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	glaceon: {
		randomBattleMoves: ["healbell", "hiddenpowerground", "icebeam", "protect", "shadowball", "toxic", "wish"],
		randomDoubleBattleMoves: ["helpinghand", "hiddenpowerground", "icebeam", "protect", "toxic"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	porygon: {
		tier: "NFE",
	},
	porygon2: {
		randomBattleMoves: ["discharge", "icebeam", "recover", "toxic", "triattack"],
		randomDoubleBattleMoves: ["allyswitch", "icebeam", "protect", "recover", "thunderbolt", "thunderwave", "triattack"],
		tier: "RU",
		doublesTier: "DOU",
	},
	porygonz: {
		randomBattleMoves: ["icebeam", "nastyplot", "shadowball", "thunderbolt", "triattack", "trick"],
		randomDoubleBattleMoves: ["darkpulse", "icebeam", "nastyplot", "protect", "thunderbolt", "triattack", "trick"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		randomBattleMoves: ["earthpower", "hydropump", "icebeam", "shellsmash", "spikes", "stealthrock"],
		randomDoubleBattleMoves: ["earthpower", "hiddenpowerelectric", "hydropump", "icebeam", "muddywater", "protect", "shellsmash"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		randomBattleMoves: ["aquajet", "knockoff", "liquidation", "rapidspin", "stoneedge", "swordsdance"],
		randomDoubleBattleMoves: ["aquajet", "knockoff", "liquidation", "protect", "rockslide", "stoneedge", "swordsdance"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	aerodactyl: {
		randomBattleMoves: ["defog", "doubleedge", "earthquake", "pursuit", "roost", "stealthrock", "stoneedge", "taunt"],
		randomDoubleBattleMoves: ["earthquake", "protect", "rockslide", "skydrop", "stoneedge", "tailwind", "wideguard"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	aerodactylmega: {
		randomBattleMoves: ["aerialace", "aquatail", "earthquake", "firefang", "honeclaws", "roost", "stoneedge"],
		randomDoubleBattleMoves: ["aquatail", "protect", "rockslide", "skydrop", "stoneedge", "tailwind", "wideguard"],
		tier: "UU",
		doublesTier: "DUU",
	},
	munchlax: {
		tier: "LC",
	},
	snorlax: {
		randomBattleMoves: ["bodyslam", "crunch", "curse", "earthquake", "firepunch", "pursuit", "rest", "return", "sleeptalk"],
		randomDoubleBattleMoves: ["bodyslam", "crunch", "curse", "highhorsepower", "protect", "rest", "return"],
		tier: "RU",
		doublesTier: "DUber",
	},
	articuno: {
		randomBattleMoves: ["freezedry", "hurricane", "roost", "substitute", "toxic"],
		randomDoubleBattleMoves: ["freezedry", "hurricane", "protect", "roost", "tailwind"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	zapdos: {
		randomBattleMoves: ["defog", "discharge", "heatwave", "hiddenpowerice", "roost", "toxic", "uturn"],
		randomDoubleBattleMoves: ["heatwave", "hiddenpowergrass", "hiddenpowerice", "protect", "roost", "tailwind", "thunderbolt"],
		tier: "OU",
		doublesTier: "DOU",
	},
	moltres: {
		randomBattleMoves: ["fireblast", "hurricane", "roost", "substitute", "toxic", "willowisp"],
		randomDoubleBattleMoves: ["airslash", "fireblast", "heatwave", "hurricane", "protect", "tailwind", "uturn", "willowisp"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		randomBattleMoves: ["dragondance", "earthquake", "extremespeed", "firepunch", "fly", "outrage"],
		randomDoubleBattleMoves: ["dragonclaw", "dragondance", "extremespeed", "firepunch", "fly", "protect", "roost", "superpower"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	mewtwo: {
		randomBattleMoves: ["aurasphere", "calmmind", "fireblast", "icebeam", "psystrike", "recover"],
		randomDoubleBattleMoves: ["aurasphere", "calmmind", "fireblast", "icebeam", "protect", "psystrike"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	mewtwomegax: {
		randomBattleMoves: ["bulkup", "drainpunch", "icebeam", "stoneedge", "taunt", "zenheadbutt"],
		randomDoubleBattleMoves: ["bulkup", "drainpunch", "icebeam", "stoneedge", "taunt", "zenheadbutt"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	mewtwomegay: {
		randomBattleMoves: ["aurasphere", "calmmind", "fireblast", "icebeam", "psystrike", "recover", "shadowball"],
		randomDoubleBattleMoves: ["aurasphere", "calmmind", "fireblast", "icebeam", "psystrike", "taunt", "willowisp"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	mew: {
		randomBattleMoves: ["aurasphere", "defog", "earthpower", "icebeam", "knockoff", "nastyplot", "psyshock", "roost", "stealthrock", "taunt", "willowisp"],
		randomDoubleBattleMoves: ["fakeout", "fireblast", "helpinghand", "icebeam", "protect", "psyshock", "roost", "tailwind", "taunt", "transform", "willowisp"],
		tier: "UU",
		doublesTier: "DOU",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NFE",
	},
	meganium: {
		randomBattleMoves: ["aromatherapy", "dragontail", "gigadrain", "leechseed", "lightscreen", "reflect", "synthesis", "toxic"],
		randomDoubleBattleMoves: ["dragontail", "energyball", "healpulse", "leafstorm", "leechseed", "protect", "toxic"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		randomBattleMoves: ["eruption", "extrasensory", "fireblast", "focusblast", "hiddenpowergrass"],
		randomDoubleBattleMoves: ["eruption", "extrasensory", "focusblast", "heatwave", "hiddenpowergrass"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		randomBattleMoves: ["aquajet", "crunch", "dragondance", "earthquake", "icepunch", "liquidation", "swordsdance"],
		randomDoubleBattleMoves: ["aquajet", "crunch", "dragondance", "icepunch", "liquidation", "protect"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		randomBattleMoves: ["aquatail", "doubleedge", "firepunch", "knockoff", "trick", "uturn"],
		randomDoubleBattleMoves: ["doubleedge", "followme", "helpinghand", "knockoff", "protect", "superfang", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		randomBattleMoves: ["airslash", "defog", "heatwave", "hurricane", "hypervoice", "roost", "whirlwind"],
		randomDoubleBattleMoves: ["airslash", "heatwave", "hypervoice", "hypnosis", "protect", "roost", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		randomBattleMoves: ["knockoff", "lightscreen", "reflect", "roost", "toxic", "uturn"],
		randomDoubleBattleMoves: ["bugbuzz", "encore", "knockoff", "lightscreen", "protect", "reflect", "tailwind", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		randomBattleMoves: ["megahorn", "poisonjab", "stickyweb", "suckerpunch", "toxicspikes"],
		randomDoubleBattleMoves: ["megahorn", "poisonjab", "protect", "ragepowder", "stickyweb", "toxicthread"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		randomBattleMoves: ["healbell", "hiddenpowergrass", "hydropump", "icebeam", "scald", "toxic", "voltswitch"],
		randomDoubleBattleMoves: ["icebeam", "protect", "scald", "thunderbolt", "thunderwave", "toxic"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "NFE",
	},
	togekiss: {
		randomBattleMoves: ["airslash", "aurasphere", "defog", "healbell", "nastyplot", "roost", "thunderwave"],
		randomDoubleBattleMoves: ["airslash", "dazzlinggleam", "followme", "nastyplot", "protect", "roost", "tailwind", "thunderwave"],
		tier: "UU",
		doublesTier: "DUU",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		randomBattleMoves: ["calmmind", "heatwave", "psychic", "roost", "thunderwave", "toxic", "uturn"],
		randomDoubleBattleMoves: ["heatwave", "protect", "psychic", "roost", "tailwind", "thunderwave", "uturn"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NFE",
	},
	ampharos: {
		randomBattleMoves: ["focusblast", "healbell", "hiddenpowerice", "lightscreen", "reflect", "thunderbolt", "toxic", "voltswitch"],
		randomDoubleBattleMoves: ["focusblast", "hiddenpowergrass", "hiddenpowerice", "protect", "thunderbolt", "thunderwave"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	ampharosmega: {
		randomBattleMoves: ["agility", "dragonpulse", "focusblast", "healbell", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["dragonpulse", "focusblast", "hiddenpowergrass", "hiddenpowerice", "protect", "thunderbolt"],
		tier: "RU",
		doublesTier: "DUU",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		randomBattleMoves: ["aquajet", "bellydrum", "knockoff", "liquidation", "playrough", "superpower"],
		randomDoubleBattleMoves: ["aquajet", "knockoff", "liquidation", "playrough", "protect", "superpower"],
		tier: "OU",
		doublesTier: "DUU",
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		randomBattleMoves: ["earthquake", "headsmash", "stealthrock", "suckerpunch", "toxic", "woodhammer"],
		randomDoubleBattleMoves: ["headsmash", "helpinghand", "protect", "stealthrock", "stompingtantrum", "suckerpunch", "woodhammer"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		randomBattleMoves: ["acrobatics", "encore", "leechseed", "seedbomb", "sleeppowder", "strengthsap", "substitute", "swordsdance", "toxic", "uturn"],
		randomDoubleBattleMoves: ["encore", "energyball", "helpinghand", "leechseed", "protect", "ragepowder", "sleeppowder", "strengthsap", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	aipom: {
		tier: "NFE",
	},
	ambipom: {
		randomBattleMoves: ["fakeout", "knockoff", "lowkick", "return", "seedbomb", "switcheroo", "uturn"],
		randomDoubleBattleMoves: ["fakeout", "icepunch", "knockoff", "lowkick", "protect", "return", "uturn"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		randomBattleMoves: ["earthpower", "gigadrain", "hiddenpowerfire", "solarbeam", "sunnyday"],
		randomDoubleBattleMoves: ["earthpower", "encore", "energyball", "helpinghand", "hiddenpowerfire", "protect", "solarbeam", "sunnyday"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	yanma: {
		tier: "NFE",
	},
	yanmega: {
		randomBattleMoves: ["airslash", "bugbuzz", "gigadrain", "protect", "uturn"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		randomBattleMoves: ["earthquake", "encore", "icebeam", "recover", "scald", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "icywind", "protect", "recover", "scald", "toxic"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	murkrow: {
		tier: "NFE",
	},
	honchkrow: {
		randomBattleMoves: ["bravebird", "heatwave", "pursuit", "roost", "suckerpunch", "superpower"],
		randomDoubleBattleMoves: ["bravebird", "heatwave", "protect", "roost", "suckerpunch", "superpower"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	misdreavus: {
		tier: "NFE",
	},
	mismagius: {
		randomBattleMoves: ["dazzlinggleam", "destinybond", "nastyplot", "painsplit", "shadowball", "substitute", "taunt", "thunderbolt", "willowisp"],
		randomDoubleBattleMoves: ["dazzlinggleam", "nastyplot", "protect", "shadowball", "taunt", "thunderbolt", "willowisp"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	unown: {
		randomBattleMoves: ["hiddenpowerpsychic"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	wynaut: {
		tier: "LC",
	},
	wobbuffet: {
		randomBattleMoves: ["counter", "destinybond", "encore", "mirrorcoat"],
		randomDoubleBattleMoves: ["charm", "counter", "encore", "mirrorcoat"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	girafarig: {
		randomBattleMoves: ["hypervoice", "nastyplot", "psychic", "psyshock", "substitute", "thunderbolt"],
		randomDoubleBattleMoves: ["hypervoice", "nastyplot", "protect", "psychic", "psyshock", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		randomBattleMoves: ["gyroball", "rapidspin", "spikes", "stealthrock", "toxic", "voltswitch"],
		randomDoubleBattleMoves: ["gyroball", "protect", "stealthrock", "toxic", "voltswitch"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	dunsparce: {
		randomBattleMoves: ["bite", "bodyslam", "coil", "glare", "headbutt", "rockslide", "roost"],
		randomDoubleBattleMoves: ["bite", "bodyslam", "coil", "glare", "headbutt", "protect", "rockslide"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gligar: {
		randomBattleMoves: ["defog", "earthquake", "knockoff", "roost", "stealthrock", "toxic", "uturn"],
		tier: "UU",
		doublesTier: "NFE",
	},
	gliscor: {
		randomBattleMoves: ["earthquake", "knockoff", "protect", "roost", "stealthrock", "taunt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["earthquake", "facade", "knockoff", "protect", "tailwind", "taunt"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		randomBattleMoves: ["crunch", "earthquake", "healbell", "playrough", "thunderwave"],
		randomDoubleBattleMoves: ["playrough", "protect", "snarl", "stompingtantrum", "thunderwave"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	qwilfish: {
		randomBattleMoves: ["destinybond", "liquidation", "painsplit", "spikes", "taunt", "thunderwave", "toxicspikes"],
		randomDoubleBattleMoves: ["destinybond", "liquidation", "poisonjab", "protect", "swordsdance", "taunt", "thunderwave"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	shuckle: {
		randomBattleMoves: ["encore", "infestation", "knockoff", "stealthrock", "stickyweb", "toxic"],
		randomDoubleBattleMoves: ["encore", "guardsplit", "helpinghand", "knockoff", "stealthrock", "stickyweb", "toxic"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	heracross: {
		randomBattleMoves: ["closecombat", "facade", "knockoff", "megahorn", "stoneedge", "swordsdance"],
		randomDoubleBattleMoves: ["closecombat", "facade", "knockoff", "megahorn", "protect", "swordsdance"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	heracrossmega: {
		randomBattleMoves: ["closecombat", "pinmissile", "rockblast", "substitute", "swordsdance"],
		randomDoubleBattleMoves: ["bulletseed", "closecombat", "knockoff", "pinmissile", "protect", "rockblast", "swordsdance"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	sneasel: {
		tier: "NU",
		doublesTier: "NFE",
	},
	weavile: {
		randomBattleMoves: ["iceshard", "iciclecrash", "knockoff", "lowkick", "pursuit", "swordsdance"],
		randomDoubleBattleMoves: ["fakeout", "iceshard", "iciclecrash", "knockoff", "lowkick", "protect", "swordsdance"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		randomBattleMoves: ["closecombat", "crunch", "facade", "protect", "swordsdance"],
		randomDoubleBattleMoves: ["closecombat", "crunch", "facade", "protect", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		randomBattleMoves: ["ancientpower", "earthpower", "fireblast", "hiddenpowergrass", "lavaplume", "recover", "shellsmash", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthpower", "fireblast", "heatwave", "incinerate", "protect", "stealthrock", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "NU",
		doublesTier: "NFE",
	},
	mamoswine: {
		randomBattleMoves: ["earthquake", "endeavor", "iceshard", "iciclecrash", "knockoff", "stealthrock", "superpower"],
		randomDoubleBattleMoves: ["earthquake", "iceshard", "iciclecrash", "knockoff", "protect", "rockslide", "superpower"],
		tier: "UU",
		doublesTier: "DUU",
	},
	corsola: {
		randomBattleMoves: ["powergem", "recover", "scald", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["icywind", "powergem", "protect", "scald", "stealthrock", "toxic"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		randomBattleMoves: ["energyball", "fireblast", "gunkshot", "hydropump", "icebeam", "rockblast", "scald"],
		randomDoubleBattleMoves: ["energyball", "fireblast", "hydropump", "icebeam", "protect"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	delibird: {
		randomBattleMoves: ["destinybond", "freezedry", "icywind", "rapidspin", "spikes"],
		randomDoubleBattleMoves: ["aerialace", "brickbreak", "fakeout", "icepunch", "iceshard", "protect"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mantyke: {
		tier: "LC",
	},
	mantine: {
		randomBattleMoves: ["airslash", "defog", "roost", "scald", "toxic"],
		randomDoubleBattleMoves: ["defog", "helpinghand", "protect", "scald", "tailwind", "toxic", "wideguard"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	skarmory: {
		randomBattleMoves: ["bravebird", "roost", "spikes", "stealthrock", "whirlwind"],
		randomDoubleBattleMoves: ["bravebird", "feint", "ironhead", "protect", "skydrop", "stealthrock", "tailwind", "taunt"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	houndour: {
		tier: "LC",
	},
	houndoom: {
		randomBattleMoves: ["darkpulse", "fireblast", "hiddenpowergrass", "nastyplot", "suckerpunch"],
		randomDoubleBattleMoves: ["darkpulse", "heatwave", "nastyplot", "protect", "suckerpunch"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	houndoommega: {
		randomBattleMoves: ["darkpulse", "fireblast", "hiddenpowergrass", "nastyplot", "taunt"],
		randomDoubleBattleMoves: ["darkpulse", "heatwave", "hiddenpowergrass", "nastyplot", "protect", "taunt"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		randomBattleMoves: ["earthquake", "iceshard", "knockoff", "rapidspin", "stealthrock", "stoneedge"],
		randomDoubleBattleMoves: ["earthquake", "iceshard", "knockoff", "protect", "rapidspin", "rockslide", "stealthrock"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	stantler: {
		randomBattleMoves: ["doubleedge", "earthquake", "jumpkick", "megahorn", "suckerpunch"],
		randomDoubleBattleMoves: ["earthquake", "jumpkick", "megahorn", "protect", "return", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	smeargle: {
		randomBattleMoves: ["destinybond", "spore", "stealthrock", "stickyweb", "whirlwind"],
		randomDoubleBattleMoves: ["fakeout", "followme", "helpinghand", "kingsshield", "spore", "stickyweb", "tailwind", "transform", "wideguard"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	miltank: {
		randomBattleMoves: ["bodyslam", "curse", "earthquake", "healbell", "milkdrink", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["bodyslam", "curse", "helpinghand", "milkdrink", "protect", "stompingtantrum", "thunderwave"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	raikou: {
		randomBattleMoves: ["aurasphere", "calmmind", "hiddenpowerice", "substitute", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["calmmind", "hiddenpowerice", "protect", "snarl", "thunderbolt"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	entei: {
		randomBattleMoves: ["extremespeed", "flareblitz", "sacredfire", "stompingtantrum", "stoneedge"],
		randomDoubleBattleMoves: ["extremespeed", "flareblitz", "protect", "sacredfire", "stompingtantrum", "stoneedge"],
		tier: "RUBL",
		doublesTier: "DUU",
	},
	suicune: {
		randomBattleMoves: ["calmmind", "hiddenpowergrass", "hydropump", "icebeam", "rest", "scald", "sleeptalk"],
		randomDoubleBattleMoves: ["icebeam", "scald", "snarl", "tailwind", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		randomBattleMoves: ["crunch", "earthquake", "fireblast", "icebeam", "pursuit", "stealthrock", "stoneedge"],
		randomDoubleBattleMoves: ["crunch", "fireblast", "icebeam", "protect", "rockslide", "stealthrock", "stompingtantrum", "stoneedge"],
		tier: "OU",
		doublesTier: "DOU",
	},
	tyranitarmega: {
		randomBattleMoves: ["crunch", "dragondance", "earthquake", "icepunch", "stoneedge"],
		randomDoubleBattleMoves: ["crunch", "dragondance", "earthquake", "icepunch", "protect", "rockslide", "stoneedge"],
		tier: "OU",
		doublesTier: "DOU",
	},
	lugia: {
		randomBattleMoves: ["aeroblast", "earthquake", "roost", "substitute", "toxic", "whirlwind"],
		randomDoubleBattleMoves: ["aeroblast", "protect", "psychic", "roost", "skydrop", "tailwind", "toxic"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	hooh: {
		randomBattleMoves: ["bravebird", "defog", "earthquake", "roost", "sacredfire", "substitute", "toxic"],
		randomDoubleBattleMoves: ["bravebird", "earthpower", "protect", "roost", "sacredfire", "skydrop", "tailwind", "toxic"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	celebi: {
		randomBattleMoves: ["earthpower", "gigadrain", "hiddenpowerfire", "leafstorm", "nastyplot", "psychic", "recover", "thunderwave", "uturn"],
		randomDoubleBattleMoves: ["earthpower", "energyball", "nastyplot", "protect", "psychic", "recover", "thunderwave", "uturn"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		randomBattleMoves: ["focusblast", "gigadrain", "hiddenpowerfire", "hiddenpowerice", "leafstorm", "leechseed", "substitute"],
		randomDoubleBattleMoves: ["energyball", "focusblast", "hiddenpowerfire", "hiddenpowerice", "protect"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	sceptilemega: {
		randomBattleMoves: ["dragonpulse", "earthquake", "focusblast", "gigadrain", "hiddenpowerfire", "leafblade", "outrage", "substitute", "swordsdance"],
		randomDoubleBattleMoves: ["dragonpulse", "energyball", "focusblast", "hiddenpowerfire", "hiddenpowerice", "leafstorm", "protect"],
		tier: "RU",
		doublesTier: "DUU",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "NFE",
	},
	blaziken: {
		randomBattleMoves: ["fireblast", "hiddenpowerice", "highjumpkick", "knockoff", "protect"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	blazikenmega: {
		randomBattleMoves: ["flareblitz", "highjumpkick", "knockoff", "protect", "stoneedge", "swordsdance"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		randomBattleMoves: ["earthquake", "icebeam", "protect", "roar", "scald", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "icywind", "muddywater", "protect", "scald", "stealthrock", "wideguard"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	swampertmega: {
		randomBattleMoves: ["earthquake", "icepunch", "raindance", "superpower", "waterfall"],
		randomDoubleBattleMoves: ["earthquake", "icepunch", "protect", "raindance", "waterfall"],
		tier: "OU",
		doublesTier: "DOU",
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		randomBattleMoves: ["crunch", "firefang", "irontail", "playrough", "suckerpunch"],
		randomDoubleBattleMoves: ["crunch", "firefang", "playrough", "protect", "suckerpunch", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	zigzagoon: {
		tier: "LC",
	},
	linoone: {
		randomBattleMoves: ["bellydrum", "extremespeed", "shadowclaw", "stompingtantrum"],
		randomDoubleBattleMoves: ["bellydrum", "extremespeed", "protect", "shadowclaw", "stompingtantrum"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	wurmple: {
		tier: "LC",
	},
	silcoon: {
		tier: "NFE",
	},
	beautifly: {
		randomBattleMoves: ["bugbuzz", "energyball", "hiddenpowerfighting", "psychic", "quiverdance"],
		randomDoubleBattleMoves: ["aircutter", "bugbuzz", "protect", "quiverdance", "stringshot", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cascoon: {
		tier: "NFE",
	},
	dustox: {
		randomBattleMoves: ["bugbuzz", "defog", "quiverdance", "roost", "sludgebomb", "uturn"],
		randomDoubleBattleMoves: ["bugbuzz", "protect", "sludgebomb", "stringshot", "strugglebug", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		randomBattleMoves: ["focusblast", "gigadrain", "hydropump", "icebeam", "raindance", "scald"],
		randomDoubleBattleMoves: ["fakeout", "gigadrain", "hydropump", "icebeam", "protect", "raindance"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		randomBattleMoves: ["defog", "knockoff", "leafstorm", "lowkick", "seedbomb", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["fakeout", "knockoff", "leafblade", "leafstorm", "protect", "suckerpunch", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	taillow: {
		tier: "LC",
	},
	swellow: {
		randomBattleMoves: ["bravebird", "facade", "protect", "quickattack", "uturn"],
		randomDoubleBattleMoves: ["bravebird", "facade", "protect", "quickattack", "uturn"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	wingull: {
		tier: "NFE",
	},
	pelipper: {
		randomBattleMoves: ["defog", "hurricane", "hydropump", "knockoff", "roost", "scald", "uturn"],
		randomDoubleBattleMoves: ["hurricane", "protect", "scald", "tailwind", "uturn", "wideguard"],
		tier: "OU",
		doublesTier: "DOU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		randomBattleMoves: ["calmmind", "focusblast", "moonblast", "psychic", "shadowball", "substitute", "thunderbolt", "willowisp"],
		randomDoubleBattleMoves: ["dazzlinggleam", "focusblast", "helpinghand", "moonblast", "protect", "psyshock"],
		tier: "RU",
		doublesTier: "DUU",
	},
	gardevoirmega: {
		randomBattleMoves: ["calmmind", "focusblast", "hypervoice", "psyshock", "substitute", "taunt", "willowisp"],
		randomDoubleBattleMoves: ["calmmind", "focusblast", "hypervoice", "protect", "psyshock"],
		tier: "UUBL",
		doublesTier: "DOU",
	},
	gallade: {
		randomBattleMoves: ["bulkup", "closecombat", "drainpunch", "icepunch", "knockoff", "shadowsneak", "substitute", "zenheadbutt"],
		randomDoubleBattleMoves: ["closecombat", "helpinghand", "icepunch", "knockoff", "protect", "shadowsneak", "trick", "zenheadbutt"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	gallademega: {
		randomBattleMoves: ["closecombat", "icepunch", "knockoff", "swordsdance", "zenheadbutt"],
		randomDoubleBattleMoves: ["closecombat", "drainpunch", "icepunch", "knockoff", "protect", "swordsdance", "zenheadbutt"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		randomBattleMoves: ["airslash", "bugbuzz", "hydropump", "quiverdance", "stickyweb"],
		randomDoubleBattleMoves: ["airslash", "bugbuzz", "hydropump", "protect", "quiverdance", "stickyweb", "strugglebug", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		randomBattleMoves: ["bulletseed", "machpunch", "rocktomb", "spore", "swordsdance"],
		randomDoubleBattleMoves: ["bulletseed", "machpunch", "protect", "rocktomb", "spore"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		tier: "NFE",
	},
	slaking: {
		randomBattleMoves: ["earthquake", "firepunch", "gigaimpact", "nightslash", "pursuit", "retaliate"],
		randomDoubleBattleMoves: ["doubleedge", "earthquake", "hammerarm", "nightslash", "retaliate", "rockslide"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		randomBattleMoves: ["aerialace", "dig", "leechlife", "nightslash", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["aerialace", "dig", "leechlife", "protect", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	shedinja: {
		randomBattleMoves: ["shadowclaw", "shadowsneak", "swordsdance", "willowisp", "xscissor"],
		randomDoubleBattleMoves: ["allyswitch", "protect", "shadowsneak", "swordsdance", "willowisp", "xscissor"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		randomBattleMoves: ["boomburst", "fireblast", "focusblast", "icebeam", "surf"],
		randomDoubleBattleMoves: ["boomburst", "fireblast", "focusblast", "hypervoice", "icebeam", "protect"],
		tier: "NUBL",
		doublesTier: "(DUU)",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		randomBattleMoves: ["bulkup", "bulletpunch", "closecombat", "icepunch", "knockoff", "stoneedge"],
		randomDoubleBattleMoves: ["bulletpunch", "closecombat", "facade", "fakeout", "helpinghand", "knockoff", "protect", "wideguard"],
		tier: "NU",
		doublesTier: "DUU",
	},
	nosepass: {
		tier: "LC",
	},
	probopass: {
		randomBattleMoves: ["earthpower", "flashcannon", "stealthrock", "thunderwave", "toxic", "voltswitch"],
		randomDoubleBattleMoves: ["flashcannon", "helpinghand", "powergem", "protect", "stealthrock", "thunderwave", "wideguard"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	skitty: {
		tier: "LC",
	},
	delcatty: {
		randomBattleMoves: ["doubleedge", "fakeout", "healbell", "suckerpunch", "thunderwave", "wildcharge"],
		randomDoubleBattleMoves: ["doubleedge", "fakeout", "helpinghand", "protect", "suckerpunch", "thunderwave"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	sableye: {
		randomBattleMoves: ["foulplay", "recover", "taunt", "toxic", "willowisp"],
		randomDoubleBattleMoves: ["fakeout", "foulplay", "helpinghand", "protect", "recover", "snarl", "taunt", "willowisp"],
		tier: "PU",
		doublesTier: "DUU",
	},
	sableyemega: {
		randomBattleMoves: ["calmmind", "darkpulse", "recover", "shadowball", "willowisp"],
		randomDoubleBattleMoves: ["fakeout", "knockoff", "protect", "recover", "shadowball", "willowisp"],
		tier: "OU",
		doublesTier: "DUU",
	},
	mawile: {
		randomBattleMoves: ["ironhead", "knockoff", "playrough", "stealthrock", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["ironhead", "knockoff", "playrough", "protect", "suckerpunch", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mawilemega: {
		randomBattleMoves: ["firefang", "focuspunch", "ironhead", "knockoff", "playrough", "substitute", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["ironhead", "knockoff", "playrough", "protect", "suckerpunch", "swordsdance"],
		tier: "OU",
		doublesTier: "DUU",
	},
	aron: {
		tier: "LC",
	},
	lairon: {
		tier: "NFE",
	},
	aggron: {
		randomBattleMoves: ["aquatail", "earthquake", "headsmash", "heavyslam", "rockpolish", "stealthrock"],
		randomDoubleBattleMoves: ["headsmash", "heavyslam", "protect", "stealthrock", "stompingtantrum"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	aggronmega: {
		randomBattleMoves: ["earthquake", "heavyslam", "roar", "stealthrock", "stoneedge", "thunderwave", "toxic"],
		randomDoubleBattleMoves: ["heavyslam", "protect", "rockslide", "stealthrock", "stompingtantrum", "toxic"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	meditite: {
		tier: "NFE",
	},
	medicham: {
		randomBattleMoves: ["bulletpunch", "drainpunch", "highjumpkick", "icepunch", "zenheadbutt"],
		randomDoubleBattleMoves: ["bulletpunch", "drainpunch", "fakeout", "highjumpkick", "icepunch", "protect", "zenheadbutt"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	medichammega: {
		randomBattleMoves: ["fakeout", "highjumpkick", "icepunch", "thunderpunch", "zenheadbutt"],
		randomDoubleBattleMoves: ["bulletpunch", "drainpunch", "fakeout", "highjumpkick", "icepunch", "protect", "zenheadbutt"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		randomBattleMoves: ["flamethrower", "hiddenpowergrass", "hiddenpowerice", "overheat", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["flamethrower", "hiddenpowergrass", "hiddenpowerice", "protect", "snarl", "switcheroo", "thunderbolt", "voltswitch"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	manectricmega: {
		randomBattleMoves: ["hiddenpowergrass", "hiddenpowerice", "overheat", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["flamethrower", "hiddenpowergrass", "hiddenpowerice", "protect", "snarl", "thunderbolt", "voltswitch"],
		tier: "UU",
		doublesTier: "DOU",
	},
	plusle: {
		randomBattleMoves: ["encore", "hiddenpowerice", "nastyplot", "substitute", "thunderbolt"],
		randomDoubleBattleMoves: ["encore", "helpinghand", "hiddenpowerice", "nastyplot", "protect", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	minun: {
		randomBattleMoves: ["encore", "hiddenpowerice", "nastyplot", "substitute", "thunderbolt"],
		randomDoubleBattleMoves: ["encore", "helpinghand", "hiddenpowerice", "nastyplot", "protect", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	volbeat: {
		randomBattleMoves: ["defog", "encore", "roost", "tailwind", "thunderwave", "uturn"],
		randomDoubleBattleMoves: ["encore", "helpinghand", "protect", "stringshot", "strugglebug", "tailwind", "thunderwave", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	illumise: {
		randomBattleMoves: ["bugbuzz", "defog", "encore", "roost", "thunderwave", "uturn", "wish"],
		randomDoubleBattleMoves: ["bugbuzz", "encore", "helpinghand", "protect", "tailwind", "thunderwave"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	budew: {
		tier: "LC",
	},
	roselia: {
		tier: "PU",
		doublesTier: "NFE",
	},
	roserade: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "leafstorm", "sleeppowder", "sludgebomb", "spikes", "synthesis", "toxicspikes"],
		randomDoubleBattleMoves: ["gigadrain", "hiddenpowerfire", "leafstorm", "protect", "sleeppowder", "sludgebomb"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		randomBattleMoves: ["earthquake", "encore", "icebeam", "painsplit", "sludgebomb", "toxic", "yawn"],
		randomDoubleBattleMoves: ["encore", "icebeam", "poisongas", "protect", "sludgebomb", "yawn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		randomBattleMoves: ["crunch", "earthquake", "icebeam", "protect", "waterfall"],
		randomDoubleBattleMoves: ["crunch", "icebeam", "liquidation", "protect", "psychicfangs"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	sharpedomega: {
		randomBattleMoves: ["crunch", "destinybond", "icefang", "protect", "psychicfangs", "waterfall"],
		randomDoubleBattleMoves: ["crunch", "icefang", "liquidation", "protect", "psychicfangs"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		randomBattleMoves: ["hiddenpowerfire", "hiddenpowergrass", "hydropump", "icebeam", "waterspout"],
		randomDoubleBattleMoves: ["hiddenpowerfire", "hiddenpowergrass", "hydropump", "icebeam", "waterspout"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		randomBattleMoves: ["earthpower", "fireblast", "hiddenpowergrass", "lavaplume", "roar", "rockpolish", "stealthrock", "stoneedge"],
		randomDoubleBattleMoves: ["earthpower", "fireblast", "heatwave", "incinerate", "protect", "stealthrock"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cameruptmega: {
		randomBattleMoves: ["ancientpower", "earthpower", "fireblast", "stealthrock", "toxic", "willowisp"],
		randomDoubleBattleMoves: ["earthpower", "fireblast", "heatwave", "protect", "rockslide"],
		tier: "NUBL",
		doublesTier: "DOU",
	},
	torkoal: {
		randomBattleMoves: ["earthpower", "fireblast", "lavaplume", "rapidspin", "shellsmash", "solarbeam", "stealthrock", "yawn"],
		randomDoubleBattleMoves: ["earthpower", "fireblast", "heatwave", "protect", "solarbeam", "willowisp"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	spoink: {
		tier: "LC",
	},
	grumpig: {
		randomBattleMoves: ["focusblast", "healbell", "lightscreen", "psychic", "reflect", "thunderwave", "toxic", "whirlwind"],
		randomDoubleBattleMoves: ["focusblast", "lightscreen", "protect", "psychic", "reflect", "taunt", "thunderwave"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	spinda: {
		randomBattleMoves: ["encore", "return", "rockslide", "superpower"],
		randomDoubleBattleMoves: ["fakeout", "protect", "return", "suckerpunch", "superpower", "trickroom"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	trapinch: {
		tier: "NFE",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		randomBattleMoves: ["defog", "dragondance", "earthquake", "firepunch", "outrage", "roost", "uturn"],
		randomDoubleBattleMoves: ["dragonclaw", "dragondance", "earthquake", "fireblast", "protect", "tailwind", "uturn"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		randomBattleMoves: ["darkpulse", "drainpunch", "focusblast", "gigadrain", "seedbomb", "spikes", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["drainpunch", "seedbomb", "spikyshield", "substitute", "suckerpunch", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		randomBattleMoves: ["defog", "dracometeor", "earthquake", "fireblast", "roost", "toxic"],
		randomDoubleBattleMoves: ["dracometeor", "dragonclaw", "fireblast", "protect", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	altariamega: {
		randomBattleMoves: ["dragondance", "earthquake", "fireblast", "healbell", "return", "roost"],
		randomDoubleBattleMoves: ["doubleedge", "dragondance", "earthquake", "fireblast", "protect", "return"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	zangoose: {
		randomBattleMoves: ["closecombat", "facade", "knockoff", "quickattack", "swordsdance"],
		randomDoubleBattleMoves: ["closecombat", "facade", "knockoff", "protect", "quickattack"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	seviper: {
		randomBattleMoves: ["darkpulse", "earthquake", "flamethrower", "gigadrain", "poisonjab", "sludgewave", "suckerpunch", "switcheroo", "swordsdance"],
		randomDoubleBattleMoves: ["aquatail", "earthquake", "flamethrower", "gigadrain", "glare", "poisonjab", "protect", "sludgebomb", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	lunatone: {
		randomBattleMoves: ["earthpower", "icebeam", "moonblast", "moonlight", "powergem", "psychic", "rockpolish", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthpower", "helpinghand", "powergem", "protect", "psychic", "trickroom"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	solrock: {
		randomBattleMoves: ["earthquake", "morningsun", "rockslide", "stealthrock", "willowisp"],
		randomDoubleBattleMoves: ["helpinghand", "protect", "rockslide", "stealthrock", "stoneedge", "willowisp", "zenheadbutt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		randomBattleMoves: ["dragondance", "earthquake", "stoneedge", "waterfall", "zenheadbutt"],
		randomDoubleBattleMoves: ["dragondance", "earthquake", "protect", "stoneedge", "waterfall", "zenheadbutt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		randomBattleMoves: ["aquajet", "crabhammer", "dragondance", "knockoff", "superpower", "swordsdance"],
		randomDoubleBattleMoves: ["aquajet", "crabhammer", "dragondance", "knockoff", "protect", "superpower", "swordsdance"],
		tier: "UU",
		doublesTier: "DUU",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		randomBattleMoves: ["earthquake", "icebeam", "psychic", "rapidspin", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["allyswitch", "earthpower", "protect", "rapidspin", "stealthrock", "toxic"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	lileep: {
		tier: "LC",
	},
	cradily: {
		randomBattleMoves: ["curse", "gigadrain", "recover", "rockslide", "seedbomb", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["gigadrain", "protect", "recover", "rockslide", "stealthrock", "stringshot", "toxic"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	anorith: {
		tier: "LC",
	},
	armaldo: {
		randomBattleMoves: ["earthquake", "knockoff", "rapidspin", "stealthrock", "stoneedge", "toxic", "xscissor"],
		randomDoubleBattleMoves: ["knockoff", "protect", "rockslide", "stoneedge", "stringshot", "swordsdance", "xscissor"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		randomBattleMoves: ["dragontail", "icebeam", "recover", "scald", "toxic"],
		randomDoubleBattleMoves: ["hypnosis", "icywind", "protect", "recover", "scald"],
		tier: "RU",
		doublesTier: "DOU",
	},
	castform: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	castformsunny: {
		randomBattleMoves: ["fireblast", "icebeam", "solarbeam", "sunnyday"],
	},
	castformrainy: {
		randomBattleMoves: ["hurricane", "hydropump", "raindance", "thunder"],
	},
	castformsnowy: {
		randomBattleMoves: ["blizzard", "fireblast", "hail", "thunderbolt"],
	},
	kecleon: {
		randomBattleMoves: ["drainpunch", "fakeout", "knockoff", "recover", "shadowsneak", "stealthrock", "suckerpunch"],
		randomDoubleBattleMoves: ["drainpunch", "fakeout", "knockoff", "protect", "shadowsneak", "trickroom"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	shuppet: {
		tier: "LC",
	},
	banette: {
		randomBattleMoves: ["destinybond", "knockoff", "shadowclaw", "shadowsneak", "suckerpunch", "taunt", "willowisp"],
		randomDoubleBattleMoves: ["knockoff", "protect", "shadowclaw", "shadowsneak", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	banettemega: {
		randomBattleMoves: ["destinybond", "knockoff", "shadowclaw", "suckerpunch", "taunt", "willowisp"],
		randomDoubleBattleMoves: ["destinybond", "knockoff", "protect", "shadowclaw", "suckerpunch", "taunt", "willowisp"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		tier: "NFE",
	},
	dusknoir: {
		randomBattleMoves: ["earthquake", "focuspunch", "icepunch", "painsplit", "shadowsneak", "substitute", "willowisp"],
		randomDoubleBattleMoves: ["allyswitch", "helpinghand", "icepunch", "painsplit", "protect", "shadowsneak", "trickroom", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	tropius: {
		randomBattleMoves: ["airslash", "gigadrain", "leechseed", "protect", "substitute", "toxic"],
		randomDoubleBattleMoves: ["airslash", "gigadrain", "leechseed", "protect", "roost", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	chingling: {
		tier: "LC",
	},
	chimecho: {
		randomBattleMoves: ["calmmind", "healbell", "healingwish", "psychic", "recover", "shadowball", "taunt", "yawn"],
		randomDoubleBattleMoves: ["helpinghand", "protect", "psychic", "recover", "taunt", "thunderwave", "trickroom"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	absol: {
		randomBattleMoves: ["knockoff", "playrough", "pursuit", "suckerpunch", "superpower", "swordsdance"],
		randomDoubleBattleMoves: ["knockoff", "playrough", "protect", "suckerpunch", "superpower", "swordsdance"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	absolmega: {
		randomBattleMoves: ["icebeam", "knockoff", "playrough", "pursuit", "suckerpunch", "superpower", "swordsdance"],
		randomDoubleBattleMoves: ["fireblast", "knockoff", "playrough", "protect", "suckerpunch", "superpower", "swordsdance"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		randomBattleMoves: ["earthquake", "explosion", "icebeam", "iceshard", "spikes", "superfang", "taunt"],
		randomDoubleBattleMoves: ["earthquake", "freezedry", "icebeam", "iceshard", "protect", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	glaliemega: {
		randomBattleMoves: ["earthquake", "explosion", "freezedry", "iceshard", "return", "spikes"],
		randomDoubleBattleMoves: ["earthquake", "explosion", "freezedry", "iceshard", "protect", "return"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	froslass: {
		randomBattleMoves: ["destinybond", "icebeam", "shadowball", "spikes", "taunt", "thunderwave"],
		randomDoubleBattleMoves: ["destinybond", "icebeam", "protect", "shadowball", "taunt", "thunderwave", "willowisp"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "NFE",
	},
	walrein: {
		randomBattleMoves: ["icebeam", "protect", "roar", "superfang", "surf", "toxic"],
		randomDoubleBattleMoves: ["brine", "icywind", "protect", "superfang"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	clamperl: {
		tier: "LC",
	},
	huntail: {
		randomBattleMoves: ["icebeam", "shellsmash", "suckerpunch", "waterfall"],
		randomDoubleBattleMoves: ["icebeam", "protect", "shellsmash", "suckerpunch", "waterfall"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gorebyss: {
		randomBattleMoves: ["hiddenpowergrass", "hydropump", "icebeam", "shellsmash"],
		randomDoubleBattleMoves: ["hiddenpowergrass", "hydropump", "icebeam", "protect", "shellsmash"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	relicanth: {
		randomBattleMoves: ["doubleedge", "earthquake", "headsmash", "stealthrock", "toxic", "waterfall"],
		randomDoubleBattleMoves: ["doubleedge", "earthquake", "headsmash", "protect", "rockslide", "waterfall"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	luvdisc: {
		randomBattleMoves: ["icebeam", "protect", "scald", "sweetkiss", "toxic"],
		randomDoubleBattleMoves: ["healpulse", "icebeam", "icywind", "protect", "scald", "sweetkiss", "toxic"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NFE",
	},
	salamence: {
		randomBattleMoves: ["dragondance", "earthquake", "fireblast", "fly", "outrage", "roost"],
		randomDoubleBattleMoves: ["dracometeor", "dragonclaw", "dragondance", "earthquake", "fireblast", "fly", "protect", "tailwind"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	salamencemega: {
		randomBattleMoves: ["doubleedge", "dracometeor", "dragondance", "earthquake", "fireblast", "return", "roost"],
		randomDoubleBattleMoves: ["doubleedge", "dracometeor", "dragonclaw", "dragondance", "earthquake", "fireblast", "protect", "return"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "NFE",
	},
	metagross: {
		randomBattleMoves: ["agility", "bulletpunch", "earthquake", "explosion", "icepunch", "meteormash", "stealthrock", "thunderpunch", "zenheadbutt"],
		randomDoubleBattleMoves: ["agility", "bulletpunch", "icepunch", "meteormash", "protect", "stompingtantrum", "thunderpunch", "zenheadbutt"],
		tier: "RU",
		doublesTier: "DUU",
	},
	metagrossmega: {
		randomBattleMoves: ["agility", "earthquake", "hammerarm", "icepunch", "meteormash", "zenheadbutt"],
		randomDoubleBattleMoves: ["icepunch", "meteormash", "protect", "stompingtantrum", "thunderpunch", "zenheadbutt"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	regirock: {
		randomBattleMoves: ["curse", "drainpunch", "rest", "rockslide", "stealthrock", "stoneedge", "thunderwave", "toxic"],
		randomDoubleBattleMoves: ["curse", "drainpunch", "protect", "rest", "rockslide", "stealthrock", "stoneedge", "thunderwave"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	regice: {
		randomBattleMoves: ["focusblast", "icebeam", "rest", "rockpolish", "sleeptalk", "thunderbolt", "thunderwave"],
		randomDoubleBattleMoves: ["icebeam", "icywind", "protect", "rockpolish", "thunderbolt", "thunderwave"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	registeel: {
		randomBattleMoves: ["curse", "ironhead", "rest", "sleeptalk", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["curse", "ironhead", "protect", "rest", "seismictoss", "stealthrock", "thunderwave"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	latias: {
		randomBattleMoves: ["dracometeor", "healingwish", "hiddenpowerfire", "psychic", "trick"],
		randomDoubleBattleMoves: ["dracometeor", "healpulse", "helpinghand", "protect", "psyshock", "tailwind"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	latiasmega: {
		randomBattleMoves: ["calmmind", "defog", "dracometeor", "psyshock", "roost", "surf"],
		randomDoubleBattleMoves: ["dragonpulse", "healpulse", "helpinghand", "protect", "psychic", "tailwind"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	latios: {
		randomBattleMoves: ["dracometeor", "hiddenpowerfire", "psyshock", "surf", "thunderbolt", "trick"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "hiddenpowerfire", "protect", "psyshock", "tailwind", "trick"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	latiosmega: {
		randomBattleMoves: ["calmmind", "dracometeor", "hiddenpowerfire", "psyshock", "roost"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "hiddenpowerfire", "protect", "psyshock", "tailwind"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	kyogre: {
		randomBattleMoves: ["icebeam", "originpulse", "scald", "thunder", "waterspout"],
		randomDoubleBattleMoves: ["calmmind", "icebeam", "originpulse", "protect", "thunder", "waterspout"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	kyogreprimal: {
		randomBattleMoves: ["calmmind", "icebeam", "originpulse", "rest", "scald", "sleeptalk", "thunder"],
		randomDoubleBattleMoves: ["calmmind", "icebeam", "originpulse", "protect", "thunder"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	groudon: {
		randomBattleMoves: ["dragonclaw", "earthquake", "firepunch", "lavaplume", "roar", "stealthrock", "stoneedge", "thunderwave"],
		randomDoubleBattleMoves: ["firepunch", "precipiceblades", "protect", "rockpolish", "rockslide", "stoneedge", "swordsdance"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	groudonprimal: {
		randomBattleMoves: ["firepunch", "lavaplume", "precipiceblades", "rockpolish", "stealthrock", "stoneedge", "swordsdance"],
		randomDoubleBattleMoves: ["firepunch", "precipiceblades", "protect", "rockpolish", "rockslide", "stoneedge", "swordsdance"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	rayquaza: {
		randomBattleMoves: ["dracometeor", "dragonascent", "dragondance", "earthquake", "extremespeed", "outrage", "vcreate"],
		randomDoubleBattleMoves: ["dracometeor", "dragonclaw", "dragondance", "earthquake", "extremespeed", "protect", "tailwind", "vcreate"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	rayquazamega: {
		randomDoubleBattleMoves: ["dragonascent", "dragonclaw", "dragondance", "earthquake", "extremespeed", "protect", "swordsdance", "vcreate"],
		tier: "AG",
		doublesTier: "DUber",
	},
	jirachi: {
		randomBattleMoves: ["bodyslam", "firepunch", "ironhead", "stealthrock", "substitute", "toxic", "uturn", "wish"],
		randomDoubleBattleMoves: ["bodyslam", "followme", "helpinghand", "icywind", "ironhead", "protect", "thunderwave", "uturn"],
		tier: "OU",
		doublesTier: "DUber",
	},
	deoxys: {
		randomBattleMoves: ["extremespeed", "firepunch", "icebeam", "knockoff", "psychoboost", "stealthrock", "superpower"],
		randomDoubleBattleMoves: ["extremespeed", "firepunch", "icebeam", "knockoff", "protect", "psychoboost", "superpower"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	deoxysattack: {
		randomBattleMoves: ["extremespeed", "firepunch", "icebeam", "knockoff", "psychoboost", "superpower"],
		randomDoubleBattleMoves: ["extremespeed", "firepunch", "icebeam", "knockoff", "protect", "psychoboost", "superpower"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	deoxysdefense: {
		randomBattleMoves: ["knockoff", "recover", "seismictoss", "spikes", "stealthrock", "taunt", "toxic"],
		randomDoubleBattleMoves: ["lightscreen", "protect", "recover", "reflect", "seismictoss", "stealthrock", "taunt", "trickroom"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	deoxysspeed: {
		randomBattleMoves: ["knockoff", "magiccoat", "psychoboost", "spikes", "stealthrock", "superpower", "taunt"],
		randomDoubleBattleMoves: ["knockoff", "lightscreen", "protect", "psychoboost", "reflect", "superpower", "taunt"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	turtwig: {
		tier: "LC",
	},
	grotle: {
		tier: "NFE",
	},
	torterra: {
		randomBattleMoves: ["earthquake", "rockpolish", "stealthrock", "stoneedge", "synthesis", "woodhammer"],
		randomDoubleBattleMoves: ["earthquake", "protect", "rockpolish", "rockslide", "stoneedge", "wideguard", "woodhammer"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	chimchar: {
		tier: "LC",
	},
	monferno: {
		tier: "NFE",
	},
	infernape: {
		randomBattleMoves: ["closecombat", "fireblast", "flareblitz", "focusblast", "grassknot", "nastyplot", "stealthrock", "stoneedge", "swordsdance", "uturn", "vacuumwave"],
		randomDoubleBattleMoves: ["closecombat", "fakeout", "feint", "flareblitz", "grassknot", "heatwave", "protect", "stoneedge", "taunt", "uturn"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	piplup: {
		tier: "LC",
	},
	prinplup: {
		tier: "NFE",
	},
	empoleon: {
		randomBattleMoves: ["defog", "flashcannon", "grassknot", "hydropump", "icebeam", "roar", "scald", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["defog", "flashcannon", "grassknot", "icywind", "protect", "scald"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	starly: {
		tier: "LC",
	},
	staravia: {
		tier: "NFE",
	},
	staraptor: {
		randomBattleMoves: ["bravebird", "closecombat", "doubleedge", "quickattack", "uturn"],
		randomDoubleBattleMoves: ["bravebird", "closecombat", "doubleedge", "protect", "quickattack", "tailwind", "uturn"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	bidoof: {
		tier: "LC",
	},
	bibarel: {
		randomBattleMoves: ["aquajet", "liquidation", "quickattack", "return", "swordsdance"],
		randomDoubleBattleMoves: ["aquajet", "liquidation", "quickattack", "return", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	kricketot: {
		tier: "LC",
	},
	kricketune: {
		randomBattleMoves: ["endeavor", "knockoff", "leechlife", "stickyweb", "taunt", "toxic"],
		randomDoubleBattleMoves: ["knockoff", "leechlife", "protect", "stickyweb", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		randomBattleMoves: ["crunch", "facade", "icefang", "superpower", "voltswitch", "wildcharge"],
		randomDoubleBattleMoves: ["crunch", "helpinghand", "icefang", "protect", "superpower", "voltswitch", "wildcharge"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cranidos: {
		tier: "LC",
	},
	rampardos: {
		randomBattleMoves: ["crunch", "earthquake", "firepunch", "headsmash", "rockpolish", "rockslide"],
		randomDoubleBattleMoves: ["crunch", "earthquake", "headsmash", "protect", "rockslide", "stoneedge", "zenheadbutt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	shieldon: {
		tier: "LC",
	},
	bastiodon: {
		randomBattleMoves: ["metalburst", "protect", "roar", "rockblast", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["guardsplit", "metalburst", "protect", "stealthrock", "stoneedge", "wideguard"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	burmy: {
		tier: "LC",
	},
	wormadam: {
		randomBattleMoves: ["bugbuzz", "gigadrain", "hiddenpowerrock", "leafstorm", "quiverdance"],
		randomDoubleBattleMoves: ["bugbuzz", "gigadrain", "leafstorm", "protect", "stringshot"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	wormadamsandy: {
		randomBattleMoves: ["earthquake", "protect", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "protect", "rockblast", "stringshot", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	wormadamtrash: {
		randomBattleMoves: ["flashcannon", "protect", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["bugbuzz", "flashcannon", "protect", "stringshot", "strugglebug", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mothim: {
		randomBattleMoves: ["airslash", "bugbuzz", "energyball", "quiverdance", "uturn"],
		randomDoubleBattleMoves: ["airslash", "bugbuzz", "energyball", "protect", "quiverdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		randomBattleMoves: ["infestation", "protect", "roost", "toxic", "uturn"],
		randomDoubleBattleMoves: ["attackorder", "healorder", "protect", "stringshot", "strugglebug", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pachirisu: {
		randomBattleMoves: ["nuzzle", "superfang", "thunderbolt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["followme", "helpinghand", "nuzzle", "protect", "superfang", "thunderbolt", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	buizel: {
		tier: "LC",
	},
	floatzel: {
		randomBattleMoves: ["aquajet", "brickbreak", "bulkup", "icepunch", "liquidation", "substitute", "taunt"],
		randomDoubleBattleMoves: ["aquajet", "icepunch", "liquidation", "protect", "switcheroo", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cherubi: {
		tier: "LC",
	},
	cherrim: {
		randomBattleMoves: ["dazzlinggleam", "energyball", "healingwish", "hiddenpowerfire", "synthesis"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cherrimsunshine: {
		randomBattleMoves: ["gigadrain", "hiddenpowerice", "solarbeam", "sunnyday", "weatherball"],
		randomDoubleBattleMoves: ["gigadrain", "helpinghand", "solarbeam", "sunnyday", "weatherball"],
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		randomBattleMoves: ["earthquake", "icebeam", "recover", "scald", "toxic"],
		randomDoubleBattleMoves: ["earthpower", "icywind", "muddywater", "protect", "recover", "scald"],
		tier: "PU",
		doublesTier: "DOU",
	},
	drifloon: {
		tier: "NFE",
	},
	drifblim: {
		randomBattleMoves: ["acrobatics", "destinybond", "hex", "shadowball", "substitute", "willowisp"],
		randomDoubleBattleMoves: ["acrobatics", "destinybond", "hypnosis", "protect", "shadowball", "thunderbolt", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	buneary: {
		tier: "LC",
	},
	lopunny: {
		randomBattleMoves: ["highjumpkick", "icepunch", "return", "switcheroo"],
		randomDoubleBattleMoves: ["encore", "fakeout", "firepunch", "helpinghand", "protect", "return", "switcheroo", "thunderwave"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	lopunnymega: {
		randomBattleMoves: ["fakeout", "highjumpkick", "icepunch", "return", "substitute"],
		randomDoubleBattleMoves: ["encore", "fakeout", "highjumpkick", "icepunch", "protect", "return"],
		tier: "OU",
		doublesTier: "DUU",
	},
	glameow: {
		tier: "LC",
	},
	purugly: {
		randomBattleMoves: ["fakeout", "knockoff", "quickattack", "return", "suckerpunch", "uturn"],
		randomDoubleBattleMoves: ["fakeout", "knockoff", "protect", "quickattack", "return", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		randomBattleMoves: ["crunch", "defog", "fireblast", "poisonjab", "pursuit", "suckerpunch", "taunt"],
		randomDoubleBattleMoves: ["crunch", "fireblast", "poisonjab", "protect", "snarl", "suckerpunch", "taunt"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	bronzor: {
		tier: "LC",
	},
	bronzong: {
		randomBattleMoves: ["earthquake", "explosion", "ironhead", "lightscreen", "reflect", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "explosion", "gyroball", "lightscreen", "protect", "reflect", "trickroom"],
		tier: "RU",
		doublesTier: "DUU",
	},
	chatot: {
		randomBattleMoves: ["boomburst", "chatter", "heatwave", "hiddenpowerground", "nastyplot", "substitute", "uturn"],
		randomDoubleBattleMoves: ["boomburst", "chatter", "encore", "heatwave", "hypervoice", "nastyplot", "protect", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	spiritomb: {
		randomBattleMoves: ["calmmind", "darkpulse", "psychic", "pursuit", "rest", "shadowsneak", "sleeptalk", "willowisp"],
		randomDoubleBattleMoves: ["foulplay", "icywind", "protect", "shadowsneak", "snarl", "willowisp"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "NFE",
	},
	garchomp: {
		randomBattleMoves: ["dragonclaw", "earthquake", "fireblast", "firefang", "outrage", "stealthrock", "stoneedge", "swordsdance"],
		randomDoubleBattleMoves: ["dragonclaw", "earthquake", "protect", "rockslide", "stoneedge", "swordsdance"],
		tier: "OU",
		doublesTier: "DOU",
	},
	garchompmega: {
		randomBattleMoves: ["dracometeor", "earthquake", "fireblast", "outrage", "stoneedge", "swordsdance"],
		randomDoubleBattleMoves: ["dragonclaw", "earthquake", "fireblast", "protect", "rockslide", "stoneedge", "swordsdance"],
		tier: "(OU)",
		doublesTier: "(DOU)",
	},
	riolu: {
		tier: "LC",
	},
	lucario: {
		randomBattleMoves: ["aurasphere", "closecombat", "crunch", "darkpulse", "extremespeed", "flashcannon", "meteormash", "nastyplot", "swordsdance", "vacuumwave"],
		randomDoubleBattleMoves: ["closecombat", "darkpulse", "extremespeed", "icepunch", "meteormash", "protect"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	lucariomega: {
		randomBattleMoves: ["aurasphere", "closecombat", "extremespeed", "flashcannon", "icepunch", "meteormash", "nastyplot", "swordsdance", "vacuumwave"],
		randomDoubleBattleMoves: ["closecombat", "darkpulse", "extremespeed", "icepunch", "meteormash", "protect", "swordsdance"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	hippopotas: {
		tier: "LC",
	},
	hippowdon: {
		randomBattleMoves: ["earthquake", "slackoff", "stealthrock", "stoneedge", "toxic", "whirlwind"],
		randomDoubleBattleMoves: ["earthquake", "protect", "rockslide", "slackoff", "stealthrock", "stoneedge", "whirlwind"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	skorupi: {
		tier: "LC",
	},
	drapion: {
		randomBattleMoves: ["aquatail", "earthquake", "knockoff", "poisonjab", "pursuit", "swordsdance", "taunt", "toxicspikes", "whirlwind"],
		randomDoubleBattleMoves: ["aquatail", "knockoff", "poisonjab", "protect", "snarl", "swordsdance", "taunt"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		randomBattleMoves: ["drainpunch", "gunkshot", "icepunch", "substitute", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["drainpunch", "fakeout", "gunkshot", "icepunch", "protect", "suckerpunch", "swordsdance"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	carnivine: {
		randomBattleMoves: ["knockoff", "powerwhip", "return", "sleeppowder", "substitute", "swordsdance"],
		randomDoubleBattleMoves: ["knockoff", "powerwhip", "protect", "ragepowder", "return", "sleeppowder", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	finneon: {
		tier: "LC",
	},
	lumineon: {
		randomBattleMoves: ["defog", "icebeam", "scald", "toxic", "uturn"],
		randomDoubleBattleMoves: ["defog", "icebeam", "protect", "scald", "tailwind", "toxic", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	snover: {
		tier: "LC",
	},
	abomasnow: {
		randomBattleMoves: ["blizzard", "earthquake", "focuspunch", "gigadrain", "iceshard", "leechseed", "substitute", "woodhammer"],
		randomDoubleBattleMoves: ["blizzard", "earthquake", "gigadrain", "iceshard", "protect", "woodhammer"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	abomasnowmega: {
		randomBattleMoves: ["blizzard", "earthquake", "gigadrain", "hiddenpowerfire", "iceshard", "woodhammer"],
		randomDoubleBattleMoves: ["blizzard", "earthquake", "gigadrain", "iceshard", "protect", "woodhammer"],
		tier: "NU",
		doublesTier: "DUU",
	},
	rotom: {
		randomBattleMoves: ["hiddenpowerice", "painsplit", "shadowball", "substitute", "thunderbolt", "trick", "voltswitch", "willowisp"],
		randomDoubleBattleMoves: ["electroweb", "hiddenpowerice", "protect", "shadowball", "thunderbolt", "trick", "voltswitch", "willowisp"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	rotomheat: {
		randomBattleMoves: ["hiddenpowerice", "overheat", "painsplit", "thunderbolt", "voltswitch", "willowisp"],
		randomDoubleBattleMoves: ["electroweb", "overheat", "protect", "thunderbolt", "voltswitch", "willowisp"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	rotomwash: {
		randomBattleMoves: ["defog", "hydropump", "painsplit", "thunderbolt", "trick", "voltswitch", "willowisp"],
		randomDoubleBattleMoves: ["electroweb", "hydropump", "protect", "thunderbolt", "trick", "voltswitch", "willowisp"],
		tier: "OU",
		doublesTier: "DUU",
	},
	rotomfrost: {
		randomBattleMoves: ["blizzard", "painsplit", "thunderbolt", "trick", "voltswitch", "willowisp"],
		randomDoubleBattleMoves: ["blizzard", "electroweb", "protect", "thunderbolt", "trick", "voltswitch", "willowisp"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	rotomfan: {
		randomBattleMoves: ["airslash", "defog", "painsplit", "thunderbolt", "voltswitch", "willowisp"],
		randomDoubleBattleMoves: ["airslash", "electroweb", "protect", "thunderbolt", "voltswitch", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	rotommow: {
		randomBattleMoves: ["hiddenpowerfire", "hiddenpowerice", "leafstorm", "thunderbolt", "trick", "voltswitch"],
		randomDoubleBattleMoves: ["electroweb", "hiddenpowerfire", "leafstorm", "protect", "thunderbolt", "trick", "voltswitch", "willowisp"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	uxie: {
		randomBattleMoves: ["healbell", "knockoff", "psychic", "stealthrock", "thunderwave", "uturn", "yawn"],
		randomDoubleBattleMoves: ["helpinghand", "knockoff", "protect", "psychic", "stealthrock", "thunderwave", "uturn", "yawn"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	mesprit: {
		randomBattleMoves: ["calmmind", "energyball", "healingwish", "hiddenpowerfire", "icebeam", "psychic", "psyshock", "signalbeam", "stealthrock", "uturn"],
		randomDoubleBattleMoves: ["calmmind", "helpinghand", "icebeam", "knockoff", "protect", "psychic", "thunderbolt", "trick", "uturn"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	azelf: {
		randomBattleMoves: ["dazzlinggleam", "explosion", "fireblast", "knockoff", "nastyplot", "psyshock", "stealthrock", "taunt"],
		randomDoubleBattleMoves: ["fireblast", "knockoff", "nastyplot", "protect", "psychic", "taunt", "thunderbolt", "uturn"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	dialga: {
		randomBattleMoves: ["dracometeor", "fireblast", "flashcannon", "roar", "stealthrock", "thunderbolt", "toxic"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "earthpower", "fireblast", "flashcannon", "protect", "thunderbolt"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	palkia: {
		randomBattleMoves: ["dracometeor", "fireblast", "hydropump", "spacialrend", "thunderwave"],
		randomDoubleBattleMoves: ["dracometeor", "fireblast", "hydropump", "protect", "spacialrend", "thunderbolt"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	heatran: {
		randomBattleMoves: ["earthpower", "flashcannon", "lavaplume", "magmastorm", "protect", "roar", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthpower", "flashcannon", "heatwave", "protect", "willowisp"],
		tier: "OU",
		doublesTier: "DOU",
	},
	regigigas: {
		randomBattleMoves: ["confuseray", "drainpunch", "knockoff", "return", "substitute", "thunderwave"],
		randomDoubleBattleMoves: ["icywind", "knockoff", "return", "substitute", "thunderwave", "wideguard"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	giratina: {
		randomBattleMoves: ["calmmind", "dragonpulse", "rest", "roar", "shadowball", "sleeptalk", "willowisp"],
		randomDoubleBattleMoves: ["calmmind", "dragonpulse", "dragontail", "protect", "shadowball", "tailwind", "willowisp"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	giratinaorigin: {
		randomBattleMoves: ["defog", "dracometeor", "earthquake", "hex", "shadowsneak", "thunderwave", "willowisp"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "protect", "shadowball", "shadowsneak", "tailwind", "willowisp"],
	},
	cresselia: {
		randomBattleMoves: ["calmmind", "icebeam", "moonblast", "moonlight", "psychic", "psyshock", "substitute", "thunderwave", "toxic"],
		randomDoubleBattleMoves: ["allyswitch", "helpinghand", "icywind", "moonblast", "moonlight", "protect", "psyshock", "thunderwave", "trickroom"],
		tier: "RU",
		doublesTier: "DOU",
	},
	phione: {
		randomBattleMoves: ["healbell", "icebeam", "knockoff", "scald", "toxic", "uturn"],
		randomDoubleBattleMoves: ["helpinghand", "icywind", "protect", "scald", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	manaphy: {
		randomBattleMoves: ["energyball", "icebeam", "psychic", "surf", "tailglow"],
		randomDoubleBattleMoves: ["energyball", "helpinghand", "icebeam", "protect", "scald", "surf", "tailglow"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	darkrai: {
		randomBattleMoves: ["darkpulse", "focusblast", "hypnosis", "nastyplot", "sludgebomb", "trick"],
		randomDoubleBattleMoves: ["darkpulse", "focusblast", "nastyplot", "protect", "sludgebomb", "snarl"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	shaymin: {
		randomBattleMoves: ["airslash", "earthpower", "leechseed", "psychic", "rest", "seedflare", "substitute"],
		randomDoubleBattleMoves: ["airslash", "earthpower", "leechseed", "protect", "rest", "seedflare", "substitute", "tailwind"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	shayminsky: {
		randomBattleMoves: ["airslash", "earthpower", "hiddenpowerice", "leechseed", "seedflare", "substitute"],
		randomDoubleBattleMoves: ["airslash", "earthpower", "hiddenpowerice", "protect", "rest", "seedflare", "tailwind"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	arceus: {
		randomBattleMoves: ["earthquake", "extremespeed", "recover", "shadowclaw", "swordsdance"],
		randomDoubleBattleMoves: ["earthquake", "extremespeed", "protect", "recover", "shadowclaw", "swordsdance"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	arceusbug: {
		randomBattleMoves: ["earthquake", "ironhead", "recover", "stoneedge", "swordsdance", "xscissor"],
		randomDoubleBattleMoves: ["earthquake", "ironhead", "protect", "recover", "stoneedge", "swordsdance", "xscissor"],
	},
	arceusdark: {
		randomBattleMoves: ["calmmind", "fireblast", "judgment", "recover", "toxic"],
		randomDoubleBattleMoves: ["calmmind", "focusblast", "judgment", "protect", "recover", "snarl", "willowisp"],
	},
	arceusdragon: {
		randomBattleMoves: ["defog", "earthquake", "extremespeed", "fireblast", "judgment", "outrage", "recover", "swordsdance", "willowisp"],
		randomDoubleBattleMoves: ["dragonclaw", "earthquake", "extremespeed", "protect", "recover", "swordsdance"],
	},
	arceuselectric: {
		randomBattleMoves: ["calmmind", "earthpower", "icebeam", "judgment", "recover"],
		randomDoubleBattleMoves: ["calmmind", "icebeam", "judgment", "protect", "recover"],
	},
	arceusfairy: {
		randomBattleMoves: ["calmmind", "defog", "earthpower", "judgment", "recover", "toxic", "willowisp"],
		randomDoubleBattleMoves: ["calmmind", "defog", "earthpower", "judgment", "protect", "recover", "thunderbolt", "willowisp"],
	},
	arceusfighting: {
		randomBattleMoves: ["calmmind", "icebeam", "judgment", "recover", "roar", "shadowball", "stoneedge"],
		randomDoubleBattleMoves: ["calmmind", "icebeam", "judgment", "protect", "recover", "shadowball", "willowisp"],
	},
	arceusfire: {
		randomBattleMoves: ["calmmind", "fireblast", "icebeam", "recover", "roar", "thunderbolt"],
		randomDoubleBattleMoves: ["calmmind", "heatwave", "judgment", "protect", "recover", "thunderbolt", "willowisp"],
	},
	arceusflying: {
		randomBattleMoves: ["calmmind", "earthpower", "fireblast", "judgment", "recover", "toxic"],
		randomDoubleBattleMoves: ["calmmind", "earthpower", "judgment", "protect", "recover", "tailwind"],
	},
	arceusghost: {
		randomBattleMoves: ["brickbreak", "defog", "extremespeed", "judgment", "recover", "shadowclaw", "shadowforce", "swordsdance", "toxic"],
		randomDoubleBattleMoves: ["brickbreak", "calmmind", "focusblast", "judgment", "protect", "recover", "shadowforce", "swordsdance", "willowisp"],
	},
	arceusgrass: {
		randomBattleMoves: ["calmmind", "fireblast", "icebeam", "judgment", "recover"],
		randomDoubleBattleMoves: ["calmmind", "heatwave", "icebeam", "judgment", "protect", "recover", "thunderwave"],
	},
	arceusground: {
		randomBattleMoves: ["earthquake", "icebeam", "judgment", "recover", "stealthrock", "stoneedge", "swordsdance", "toxic"],
		randomDoubleBattleMoves: ["calmmind", "earthquake", "icebeam", "judgment", "protect", "recover", "rockslide", "stoneedge", "swordsdance"],
	},
	arceusice: {
		randomBattleMoves: ["calmmind", "fireblast", "judgment", "recover", "thunderbolt"],
		randomDoubleBattleMoves: ["calmmind", "focusblast", "icywind", "judgment", "protect", "recover", "thunderbolt"],
	},
	arceuspoison: {
		randomBattleMoves: ["calmmind", "defog", "fireblast", "icebeam", "recover", "sludgebomb"],
		randomDoubleBattleMoves: ["calmmind", "earthpower", "heatwave", "judgment", "protect", "recover", "sludgebomb", "willowisp"],
	},
	arceuspsychic: {
		randomBattleMoves: ["calmmind", "fireblast", "icebeam", "judgment", "recover", "toxic"],
		randomDoubleBattleMoves: ["calmmind", "focusblast", "judgment", "protect", "psyshock", "recover", "willowisp"],
	},
	arceusrock: {
		randomBattleMoves: ["earthquake", "judgment", "recover", "stealthrock", "stoneedge", "swordsdance", "willowisp"],
		randomDoubleBattleMoves: ["earthquake", "protect", "recover", "rockslide", "stoneedge", "swordsdance"],
	},
	arceussteel: {
		randomBattleMoves: ["defog", "earthquake", "ironhead", "judgment", "recover", "roar", "stoneedge", "swordsdance", "willowisp"],
		randomDoubleBattleMoves: ["calmmind", "earthpower", "judgment", "protect", "recover", "willowisp"],
	},
	arceuswater: {
		randomBattleMoves: ["calmmind", "defog", "icebeam", "judgment", "recover", "toxic"],
		randomDoubleBattleMoves: ["calmmind", "fireblast", "icebeam", "icywind", "judgment", "protect", "recover", "surf"],
	},
	victini: {
		randomBattleMoves: ["blueflare", "boltstrike", "focusblast", "grassknot", "uturn", "vcreate", "zenheadbutt"],
		randomDoubleBattleMoves: ["blueflare", "boltstrike", "protect", "psychic", "uturn", "vcreate"],
		tier: "OU",
		doublesTier: "DOU",
	},
	snivy: {
		tier: "LC",
	},
	servine: {
		tier: "NFE",
	},
	serperior: {
		randomBattleMoves: ["dragonpulse", "glare", "hiddenpowerfire", "leafstorm", "leechseed", "substitute"],
		randomDoubleBattleMoves: ["dragonpulse", "hiddenpowerfire", "leafstorm", "protect", "taunt"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	tepig: {
		tier: "LC",
	},
	pignite: {
		tier: "NFE",
	},
	emboar: {
		randomBattleMoves: ["fireblast", "flareblitz", "grassknot", "headsmash", "suckerpunch", "superpower", "wildcharge"],
		randomDoubleBattleMoves: ["flareblitz", "headsmash", "heatwave", "protect", "rockslide", "superpower", "wildcharge"],
		tier: "NUBL",
		doublesTier: "(DUU)",
	},
	oshawott: {
		tier: "LC",
	},
	dewott: {
		tier: "NFE",
	},
	samurott: {
		randomBattleMoves: ["aquajet", "grassknot", "hydropump", "icebeam", "liquidation", "megahorn", "sacredsword", "swordsdance"],
		randomDoubleBattleMoves: ["aquajet", "helpinghand", "hiddenpowergrass", "hydropump", "icebeam", "protect", "scald", "taunt"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	patrat: {
		tier: "LC",
	},
	watchog: {
		randomBattleMoves: ["hypnosis", "knockoff", "return", "substitute", "superfang", "swordsdance"],
		randomDoubleBattleMoves: ["hypnosis", "knockoff", "protect", "return", "superfang", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	lillipup: {
		tier: "LC",
	},
	herdier: {
		tier: "NFE",
	},
	stoutland: {
		randomBattleMoves: ["crunch", "icefang", "return", "superpower", "wildcharge"],
		randomDoubleBattleMoves: ["crunch", "protect", "return", "superpower", "wildcharge"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	purrloin: {
		tier: "LC",
	},
	liepard: {
		randomBattleMoves: ["copycat", "darkpulse", "encore", "knockoff", "nastyplot", "playrough", "substitute", "thunderwave", "uturn"],
		randomDoubleBattleMoves: ["encore", "fakeout", "knockoff", "playrough", "protect", "suckerpunch", "thunderwave", "uturn"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	pansage: {
		tier: "LC",
	},
	simisage: {
		randomBattleMoves: ["focusblast", "gigadrain", "hiddenpowerice", "knockoff", "leafstorm", "nastyplot", "substitute", "superpower"],
		randomDoubleBattleMoves: ["focusblast", "gigadrain", "helpinghand", "hiddenpowerfire", "hiddenpowerice", "leafstorm", "nastyplot", "spikyshield", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pansear: {
		tier: "LC",
	},
	simisear: {
		randomBattleMoves: ["fireblast", "focusblast", "grassknot", "hiddenpowerrock", "nastyplot", "substitute"],
		randomDoubleBattleMoves: ["fireblast", "focusblast", "grassknot", "heatwave", "nastyplot", "protect", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	panpour: {
		tier: "LC",
	},
	simipour: {
		randomBattleMoves: ["focusblast", "hydropump", "icebeam", "nastyplot", "substitute"],
		randomDoubleBattleMoves: ["helpinghand", "hydropump", "icebeam", "nastyplot", "protect", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	munna: {
		tier: "LC",
	},
	musharna: {
		randomBattleMoves: ["calmmind", "healbell", "moonlight", "psychic", "psyshock", "signalbeam", "thunderwave"],
		randomDoubleBattleMoves: ["helpinghand", "hypnosis", "moonlight", "protect", "psychic", "signalbeam", "thunderwave", "trickroom"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	pidove: {
		tier: "LC",
	},
	tranquill: {
		tier: "NFE",
	},
	unfezant: {
		randomBattleMoves: ["hypnosis", "nightslash", "pluck", "return", "roost", "tailwind", "uturn"],
		randomDoubleBattleMoves: ["nightslash", "pluck", "protect", "return", "roost", "tailwind", "taunt", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	blitzle: {
		tier: "LC",
	},
	zebstrika: {
		randomBattleMoves: ["hiddenpowergrass", "overheat", "thunderbolt", "voltswitch", "wildcharge"],
		randomDoubleBattleMoves: ["hiddenpowergrass", "overheat", "protect", "voltswitch", "wildcharge"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	roggenrola: {
		tier: "LC",
	},
	boldore: {
		tier: "NFE",
	},
	gigalith: {
		randomBattleMoves: ["earthquake", "explosion", "stealthrock", "stoneedge", "superpower"],
		randomDoubleBattleMoves: ["protect", "rockslide", "stealthrock", "stompingtantrum", "stoneedge", "superpower", "wideguard"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	woobat: {
		tier: "LC",
	},
	swoobat: {
		randomBattleMoves: ["airslash", "calmmind", "heatwave", "roost", "storedpower"],
		randomDoubleBattleMoves: ["airslash", "calmmind", "heatwave", "protect", "psychic", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	drilbur: {
		tier: "LC",
	},
	excadrill: {
		randomBattleMoves: ["earthquake", "ironhead", "rapidspin", "rockslide", "swordsdance"],
		randomDoubleBattleMoves: ["drillrun", "earthquake", "ironhead", "protect", "rockslide", "swordsdance"],
		tier: "OU",
		doublesTier: "DOU",
	},
	audino: {
		randomBattleMoves: ["doubleedge", "encore", "healbell", "protect", "toxic", "wish"],
		randomDoubleBattleMoves: ["healpulse", "helpinghand", "hypervoice", "protect", "thunderwave", "trickroom"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	audinomega: {
		randomBattleMoves: ["calmmind", "dazzlinggleam", "fireblast", "healbell", "protect", "wish"],
		randomDoubleBattleMoves: ["dazzlinggleam", "healpulse", "helpinghand", "hypervoice", "protect", "thunderwave", "trickroom"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	timburr: {
		tier: "LC",
	},
	gurdurr: {
		tier: "PU",
		doublesTier: "NFE",
	},
	conkeldurr: {
		randomBattleMoves: ["bulkup", "drainpunch", "facade", "knockoff", "machpunch"],
		randomDoubleBattleMoves: ["drainpunch", "facade", "knockoff", "machpunch", "protect"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	tympole: {
		tier: "LC",
	},
	palpitoad: {
		tier: "NFE",
	},
	seismitoad: {
		randomBattleMoves: ["earthquake", "hydropump", "knockoff", "raindance", "scald", "sludgewave", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "hydropump", "muddywater", "protect", "raindance", "sludgebomb"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	throh: {
		randomBattleMoves: ["bulkup", "circlethrow", "icepunch", "knockoff", "rest", "sleeptalk", "stormthrow"],
		randomDoubleBattleMoves: ["circlethrow", "helpinghand", "icepunch", "knockoff", "protect", "stormthrow"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	sawk: {
		randomBattleMoves: ["bulkup", "closecombat", "earthquake", "icepunch", "knockoff", "poisonjab", "stoneedge"],
		randomDoubleBattleMoves: ["closecombat", "icepunch", "knockoff", "protect", "rockslide"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	sewaddle: {
		tier: "LC",
	},
	swadloon: {
		tier: "NFE",
	},
	leavanny: {
		randomBattleMoves: ["knockoff", "leafblade", "stickyweb", "swordsdance", "xscissor"],
		randomDoubleBattleMoves: ["leafblade", "protect", "stickyweb", "swordsdance", "xscissor"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	venipede: {
		tier: "LC",
	},
	whirlipede: {
		tier: "NFE",
	},
	scolipede: {
		randomBattleMoves: ["earthquake", "megahorn", "poisonjab", "protect", "spikes", "swordsdance", "toxicspikes"],
		randomDoubleBattleMoves: ["aquatail", "megahorn", "poisonjab", "protect", "rockslide", "superpower", "swordsdance"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	cottonee: {
		tier: "LC",
	},
	whimsicott: {
		randomBattleMoves: ["defog", "encore", "leechseed", "memento", "moonblast", "stunspore", "tailwind", "taunt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["dazzlinggleam", "defog", "encore", "gigadrain", "helpinghand", "leechseed", "moonblast", "protect", "stunspore", "substitute", "tailwind", "taunt", "uturn"],
		tier: "NU",
		doublesTier: "DOU",
	},
	petilil: {
		tier: "LC",
	},
	lilligant: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "hiddenpowerrock", "petaldance", "quiverdance", "sleeppowder"],
		randomDoubleBattleMoves: ["gigadrain", "helpinghand", "hiddenpowerfire", "hiddenpowerice", "hiddenpowerrock", "petaldance", "protect", "quiverdance", "sleeppowder"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	basculin: {
		randomBattleMoves: ["aquajet", "crunch", "headsmash", "liquidation", "superpower"],
		randomDoubleBattleMoves: ["aquajet", "icebeam", "liquidation", "muddywater", "protect", "superpower"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	basculinbluestriped: {
		randomBattleMoves: ["aquajet", "crunch", "headsmash", "liquidation", "superpower"],
		randomDoubleBattleMoves: ["aquajet", "icebeam", "liquidation", "muddywater", "protect", "superpower"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	sandile: {
		tier: "LC",
	},
	krokorok: {
		tier: "NFE",
	},
	krookodile: {
		randomBattleMoves: ["earthquake", "knockoff", "pursuit", "stealthrock", "stoneedge", "superpower"],
		randomDoubleBattleMoves: ["earthquake", "knockoff", "protect", "stoneedge", "superpower"],
		tier: "UU",
		doublesTier: "DUU",
	},
	darumaka: {
		tier: "LC",
	},
	darmanitan: {
		randomBattleMoves: ["earthquake", "flareblitz", "rockslide", "superpower", "uturn"],
		randomDoubleBattleMoves: ["earthquake", "flareblitz", "protect", "rockslide", "superpower", "uturn"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	maractus: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "leechseed", "spikes", "spikyshield", "suckerpunch", "toxic"],
		randomDoubleBattleMoves: ["energyball", "helpinghand", "hiddenpowerfire", "leechseed", "spikyshield", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	dwebble: {
		tier: "LC",
	},
	crustle: {
		randomBattleMoves: ["earthquake", "shellsmash", "spikes", "stealthrock", "stoneedge", "xscissor"],
		randomDoubleBattleMoves: ["earthquake", "protect", "rockslide", "shellsmash", "stoneedge", "xscissor"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	scraggy: {
		tier: "LC",
	},
	scrafty: {
		randomBattleMoves: ["bulkup", "dragondance", "drainpunch", "highjumpkick", "icepunch", "knockoff", "rest"],
		randomDoubleBattleMoves: ["drainpunch", "fakeout", "icepunch", "knockoff", "protect", "superfang"],
		tier: "NU",
		doublesTier: "DOU",
	},
	sigilyph: {
		randomBattleMoves: ["airslash", "calmmind", "heatwave", "icebeam", "psychic", "psyshock", "roost"],
		randomDoubleBattleMoves: ["airslash", "calmmind", "heatwave", "protect", "psyshock", "tailwind"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	yamask: {
		tier: "LC",
	},
	cofagrigus: {
		randomBattleMoves: ["haze", "hiddenpowerfighting", "nastyplot", "painsplit", "shadowball", "toxicspikes", "trickroom", "willowisp"],
		randomDoubleBattleMoves: ["hiddenpowerfighting", "nastyplot", "protect", "shadowball", "trickroom", "willowisp"],
		tier: "NUBL",
		doublesTier: "DUU",
	},
	tirtouga: {
		tier: "LC",
	},
	carracosta: {
		randomBattleMoves: ["aquajet", "earthquake", "liquidation", "shellsmash", "stoneedge"],
		randomDoubleBattleMoves: ["aquajet", "earthquake", "liquidation", "protect", "rockslide", "shellsmash", "stoneedge", "wideguard"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	archen: {
		tier: "LC",
	},
	archeops: {
		randomBattleMoves: ["acrobatics", "aquatail", "earthquake", "endeavor", "headsmash", "stoneedge", "uturn"],
		randomDoubleBattleMoves: ["acrobatics", "earthpower", "protect", "rockslide", "stoneedge", "tailwind", "taunt", "uturn"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	trubbish: {
		tier: "LC",
	},
	garbodor: {
		randomBattleMoves: ["gunkshot", "haze", "painsplit", "spikes", "stompingtantrum", "toxic", "toxicspikes"],
		randomDoubleBattleMoves: ["drainpunch", "gunkshot", "painsplit", "protect", "toxicspikes"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	zorua: {
		tier: "LC",
	},
	zoroark: {
		randomBattleMoves: ["darkpulse", "flamethrower", "focusblast", "nastyplot", "sludgebomb", "trick"],
		randomDoubleBattleMoves: ["darkpulse", "flamethrower", "focusblast", "knockoff", "nastyplot", "protect", "suckerpunch", "uturn"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	minccino: {
		tier: "LC",
	},
	cinccino: {
		randomBattleMoves: ["bulletseed", "knockoff", "rockblast", "tailslap", "uturn"],
		randomDoubleBattleMoves: ["bulletseed", "knockoff", "protect", "rockblast", "tailslap", "uturn"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	gothita: {
		tier: "NFE",
	},
	gothorita: {
		tier: "NFE",
	},
	gothitelle: {
		randomBattleMoves: ["charm", "confide", "rest", "taunt"],
		randomDoubleBattleMoves: ["charm", "healpulse", "protect", "psychic", "shadowball", "taunt", "thunderbolt", "trickroom"],
		tier: "(PU)",
		doublesTier: "DOU",
	},
	solosis: {
		tier: "LC",
	},
	duosion: {
		tier: "NFE",
	},
	reuniclus: {
		randomBattleMoves: ["calmmind", "focusblast", "psychic", "psyshock", "recover", "shadowball", "trickroom"],
		randomDoubleBattleMoves: ["focusblast", "helpinghand", "protect", "psychic", "shadowball", "trickroom"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	ducklett: {
		tier: "LC",
	},
	swanna: {
		randomBattleMoves: ["bravebird", "defog", "hurricane", "icebeam", "raindance", "roost", "scald"],
		randomDoubleBattleMoves: ["bravebird", "hurricane", "icebeam", "protect", "scald", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	vanillite: {
		tier: "LC",
	},
	vanillish: {
		tier: "NFE",
	},
	vanilluxe: {
		randomBattleMoves: ["autotomize", "blizzard", "explosion", "flashcannon", "freezedry", "hiddenpowerground"],
		randomDoubleBattleMoves: ["autotomize", "blizzard", "flashcannon", "freezedry", "hiddenpowerground", "protect", "taunt"],
		tier: "NUBL",
		doublesTier: "(DUU)",
	},
	deerling: {
		tier: "LC",
	},
	sawsbuck: {
		randomBattleMoves: ["hornleech", "jumpkick", "return", "substitute", "swordsdance"],
		randomDoubleBattleMoves: ["hornleech", "jumpkick", "protect", "return", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	emolga: {
		randomBattleMoves: ["acrobatics", "encore", "knockoff", "roost", "thunderbolt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["airslash", "encore", "helpinghand", "protect", "roost", "tailwind", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	karrablast: {
		tier: "LC",
	},
	escavalier: {
		randomBattleMoves: ["drillrun", "ironhead", "knockoff", "megahorn", "pursuit", "swordsdance"],
		randomDoubleBattleMoves: ["drillrun", "ironhead", "knockoff", "megahorn", "protect", "swordsdance"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	foongus: {
		tier: "LC",
	},
	amoonguss: {
		randomBattleMoves: ["clearsmog", "foulplay", "gigadrain", "hiddenpowerfire", "sludgebomb", "spore", "synthesis"],
		randomDoubleBattleMoves: ["gigadrain", "hiddenpowerfire", "protect", "ragepowder", "sludgebomb", "spore", "stunspore"],
		tier: "UU",
		doublesTier: "DOU",
	},
	frillish: {
		tier: "LC",
	},
	jellicent: {
		randomBattleMoves: ["icebeam", "recover", "scald", "shadowball", "taunt", "toxic", "willowisp"],
		randomDoubleBattleMoves: ["icywind", "protect", "recover", "scald", "shadowball", "trickroom", "willowisp"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	alomomola: {
		randomBattleMoves: ["knockoff", "protect", "scald", "toxic", "wish"],
		randomDoubleBattleMoves: ["helpinghand", "icywind", "knockoff", "protect", "scald", "wideguard"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	joltik: {
		tier: "LC",
	},
	galvantula: {
		randomBattleMoves: ["bugbuzz", "gigadrain", "hiddenpowerice", "stickyweb", "thunder", "voltswitch"],
		randomDoubleBattleMoves: ["bugbuzz", "energyball", "hiddenpowerice", "protect", "stickyweb", "thunder", "voltswitch"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	ferroseed: {
		tier: "PU",
		doublesTier: "LC",
	},
	ferrothorn: {
		randomBattleMoves: ["gyroball", "leechseed", "powerwhip", "protect", "spikes", "stealthrock"],
		randomDoubleBattleMoves: ["gyroball", "knockoff", "leechseed", "powerwhip", "protect", "stealthrock"],
		tier: "OU",
		doublesTier: "DOU",
	},
	klink: {
		tier: "LC",
	},
	klang: {
		tier: "NFE",
	},
	klinklang: {
		randomBattleMoves: ["geargrind", "return", "shiftgear", "substitute", "wildcharge"],
		randomDoubleBattleMoves: ["geargrind", "protect", "return", "shiftgear", "wildcharge"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	tynamo: {
		tier: "LC",
	},
	eelektrik: {
		tier: "NFE",
	},
	eelektross: {
		randomBattleMoves: ["flamethrower", "gigadrain", "hiddenpowerice", "knockoff", "superpower", "thunderbolt", "uturn"],
		randomDoubleBattleMoves: ["flamethrower", "gigadrain", "knockoff", "protect", "thunderbolt", "uturn", "voltswitch"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	elgyem: {
		tier: "LC",
	},
	beheeyem: {
		randomBattleMoves: ["hiddenpowerfighting", "nastyplot", "psychic", "psyshock", "signalbeam", "thunderbolt", "trick", "trickroom"],
		randomDoubleBattleMoves: ["hiddenpowerfighting", "protect", "psychic", "recover", "signalbeam", "thunderbolt", "trick", "trickroom"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	litwick: {
		tier: "LC",
	},
	lampent: {
		tier: "NFE",
	},
	chandelure: {
		randomBattleMoves: ["calmmind", "energyball", "fireblast", "hiddenpowerground", "shadowball", "substitute", "trick"],
		randomDoubleBattleMoves: ["energyball", "heatwave", "overheat", "protect", "shadowball", "trick"],
		tier: "UU",
		doublesTier: "DUU",
	},
	axew: {
		tier: "LC",
	},
	fraxure: {
		tier: "NFE",
	},
	haxorus: {
		randomBattleMoves: ["dragondance", "earthquake", "outrage", "poisonjab", "swordsdance", "taunt"],
		randomDoubleBattleMoves: ["dragonclaw", "dragondance", "earthquake", "poisonjab", "protect", "swordsdance", "taunt"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	cubchoo: {
		tier: "LC",
	},
	beartic: {
		randomBattleMoves: ["aquajet", "iciclecrash", "nightslash", "stoneedge", "superpower", "swordsdance"],
		randomDoubleBattleMoves: ["aquajet", "iciclecrash", "protect", "stoneedge", "superpower", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cryogonal: {
		randomBattleMoves: ["freezedry", "haze", "hiddenpowerground", "icebeam", "rapidspin", "recover", "toxic"],
		randomDoubleBattleMoves: ["freezedry", "hiddenpowerground", "icebeam", "icywind", "protect", "recover"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	shelmet: {
		tier: "LC",
	},
	accelgor: {
		randomBattleMoves: ["bugbuzz", "encore", "energyball", "focusblast", "hiddenpowerrock", "spikes", "toxicspikes", "yawn"],
		randomDoubleBattleMoves: ["bugbuzz", "encore", "energyball", "focusblast", "hiddenpowerrock", "protect", "sludgebomb", "yawn"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	stunfisk: {
		randomBattleMoves: ["discharge", "earthpower", "rest", "scald", "sleeptalk", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["discharge", "earthpower", "electroweb", "protect", "scald", "stealthrock"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mienfoo: {
		tier: "LC",
	},
	mienshao: {
		randomBattleMoves: ["fakeout", "highjumpkick", "knockoff", "poisonjab", "stoneedge", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["drainpunch", "fakeout", "feint", "highjumpkick", "knockoff", "protect", "stoneedge", "swordsdance", "uturn"],
		tier: "RUBL",
		doublesTier: "DUU",
	},
	druddigon: {
		randomBattleMoves: ["dragontail", "earthquake", "firepunch", "glare", "gunkshot", "outrage", "stealthrock", "suckerpunch"],
		randomDoubleBattleMoves: ["dragonclaw", "earthquake", "firepunch", "glare", "protect", "suckerpunch", "superpower", "thunderpunch"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	golett: {
		tier: "LC",
	},
	golurk: {
		randomBattleMoves: ["dynamicpunch", "earthquake", "icepunch", "rockpolish", "shadowpunch", "stealthrock"],
		randomDoubleBattleMoves: ["dynamicpunch", "earthquake", "icepunch", "protect", "rockpolish", "shadowpunch", "stoneedge"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	pawniard: {
		tier: "LC",
	},
	bisharp: {
		randomBattleMoves: ["ironhead", "knockoff", "lowkick", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["ironhead", "knockoff", "protect", "suckerpunch", "swordsdance"],
		tier: "UU",
		doublesTier: "DUU",
	},
	bouffalant: {
		randomBattleMoves: ["earthquake", "headcharge", "megahorn", "stoneedge", "superpower", "swordsdance"],
		randomDoubleBattleMoves: ["headcharge", "megahorn", "protect", "stompingtantrum", "stoneedge", "superpower", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	rufflet: {
		tier: "LC",
	},
	braviary: {
		randomBattleMoves: ["bravebird", "bulkup", "return", "roost", "substitute", "superpower", "uturn"],
		randomDoubleBattleMoves: ["bravebird", "protect", "return", "skydrop", "superpower", "tailwind", "uturn"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	vullaby: {
		tier: "LC",
	},
	mandibuzz: {
		randomBattleMoves: ["bravebird", "defog", "foulplay", "roost", "taunt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["bravebird", "knockoff", "protect", "roost", "snarl", "tailwind", "taunt", "uturn"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	heatmor: {
		randomBattleMoves: ["fireblast", "focusblast", "gigadrain", "knockoff", "suckerpunch"],
		randomDoubleBattleMoves: ["firelash", "gigadrain", "incinerate", "protect", "suckerpunch", "superpower"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	durant: {
		randomBattleMoves: ["honeclaws", "ironhead", "rockslide", "superpower", "xscissor"],
		randomDoubleBattleMoves: ["honeclaws", "ironhead", "protect", "rockslide", "superpower", "xscissor"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	deino: {
		tier: "LC",
	},
	zweilous: {
		tier: "NFE",
	},
	hydreigon: {
		randomBattleMoves: ["darkpulse", "dracometeor", "earthpower", "fireblast", "flashcannon", "roost", "superpower", "uturn"],
		randomDoubleBattleMoves: ["darkpulse", "dracometeor", "fireblast", "flashcannon", "protect", "tailwind", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	larvesta: {
		tier: "LC",
	},
	volcarona: {
		randomBattleMoves: ["bugbuzz", "fierydance", "fireblast", "gigadrain", "hiddenpowerground", "quiverdance", "roost"],
		randomDoubleBattleMoves: ["bugbuzz", "fierydance", "gigadrain", "heatwave", "protect", "quiverdance", "tailwind"],
		tier: "OU",
		doublesTier: "DOU",
	},
	cobalion: {
		randomBattleMoves: ["closecombat", "ironhead", "stealthrock", "stoneedge", "swordsdance", "voltswitch"],
		randomDoubleBattleMoves: ["closecombat", "ironhead", "protect", "stoneedge", "swordsdance", "thunderwave"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	terrakion: {
		randomBattleMoves: ["closecombat", "earthquake", "quickattack", "stealthrock", "stoneedge", "swordsdance"],
		randomDoubleBattleMoves: ["closecombat", "protect", "rockslide", "stompingtantrum", "stoneedge", "taunt"],
		tier: "UU",
		doublesTier: "DOU",
	},
	virizion: {
		randomBattleMoves: ["closecombat", "leafblade", "stoneedge", "swordsdance"],
		randomDoubleBattleMoves: ["closecombat", "leafblade", "protect", "stoneedge", "swordsdance", "taunt"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	tornadus: {
		randomBattleMoves: ["defog", "grassknot", "heatwave", "hurricane", "superpower", "tailwind", "uturn"],
		randomDoubleBattleMoves: ["heatwave", "hurricane", "protect", "skydrop", "superpower", "tailwind", "taunt", "uturn"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	tornadustherian: {
		randomBattleMoves: ["heatwave", "hurricane", "knockoff", "superpower", "taunt", "uturn"],
		randomDoubleBattleMoves: ["heatwave", "hurricane", "protect", "skydrop", "tailwind", "taunt", "uturn"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	thundurus: {
		randomBattleMoves: ["focusblast", "hiddenpowerflying", "hiddenpowerice", "knockoff", "nastyplot", "substitute", "taunt", "thunderbolt", "thunderwave"],
		randomDoubleBattleMoves: ["focusblast", "hiddenpowerflying", "hiddenpowerice", "knockoff", "nastyplot", "protect", "taunt", "thunderbolt", "thunderwave"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	thundurustherian: {
		randomBattleMoves: ["focusblast", "hiddenpowerflying", "hiddenpowerice", "nastyplot", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["focusblast", "hiddenpowerflying", "hiddenpowerice", "nastyplot", "protect", "thunderbolt", "voltswitch"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	reshiram: {
		randomBattleMoves: ["blueflare", "dracometeor", "dragonpulse", "flamecharge", "roost", "stoneedge", "toxic"],
		randomDoubleBattleMoves: ["blueflare", "dracometeor", "dragonpulse", "flamecharge", "heatwave", "protect", "roost", "tailwind"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	zekrom: {
		randomBattleMoves: ["boltstrike", "dracometeor", "dragonclaw", "honeclaws", "outrage", "roost", "substitute", "voltswitch"],
		randomDoubleBattleMoves: ["boltstrike", "dracometeor", "dragonclaw", "honeclaws", "protect", "roost", "tailwind"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	landorus: {
		randomBattleMoves: ["calmmind", "earthpower", "focusblast", "knockoff", "psychic", "rockpolish", "rockslide", "sludgewave", "stealthrock"],
		randomDoubleBattleMoves: ["earthpower", "focusblast", "hiddenpowerice", "protect", "psychic", "rockslide", "sludgebomb"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	landorustherian: {
		randomBattleMoves: ["earthquake", "fly", "rockpolish", "stealthrock", "stoneedge", "superpower", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["earthquake", "fly", "knockoff", "protect", "rockslide", "stoneedge", "superpower", "swordsdance", "uturn"],
		tier: "OU",
		doublesTier: "DOU",
	},
	kyurem: {
		randomBattleMoves: ["dracometeor", "earthpower", "focusblast", "icebeam", "outrage", "roost", "substitute"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "earthpower", "glaciate", "icebeam", "protect", "roost"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	kyuremblack: {
		randomBattleMoves: ["dragonclaw", "earthpower", "fusionbolt", "icebeam", "outrage", "roost", "substitute"],
		randomDoubleBattleMoves: ["dragonclaw", "earthpower", "fusionbolt", "icebeam", "protect", "roost"],
		tier: "OU",
		doublesTier: "DOU",
	},
	kyuremwhite: {
		randomBattleMoves: ["dracometeor", "earthpower", "focusblast", "fusionflare", "icebeam", "roost", "toxic"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "earthpower", "fusionflare", "icebeam", "protect", "roost"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	keldeo: {
		randomBattleMoves: ["calmmind", "hiddenpowerelectric", "hiddenpowerflying", "hydropump", "icywind", "scald", "secretsword", "substitute"],
		randomDoubleBattleMoves: ["calmmind", "hiddenpowerelectric", "hiddenpowerflying", "hydropump", "icywind", "protect", "secretsword", "taunt"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	keldeoresolute: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	meloetta: {
		randomBattleMoves: ["calmmind", "focusblast", "hypervoice", "psyshock", "shadowball", "trick", "uturn"],
		randomDoubleBattleMoves: ["calmmind", "focusblast", "hypervoice", "protect", "psyshock", "shadowball"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	meloettapirouette: {
		randomBattleMoves: ["closecombat", "knockoff", "relicsong", "return"],
		randomDoubleBattleMoves: ["closecombat", "knockoff", "protect", "relicsong", "return"],
	},
	genesect: {
		randomBattleMoves: ["blazekick", "extremespeed", "flamethrower", "icebeam", "ironhead", "shiftgear", "technoblast", "thunderbolt", "uturn"],
		randomDoubleBattleMoves: ["bugbuzz", "extremespeed", "flamethrower", "icebeam", "ironhead", "protect", "technoblast", "thunderbolt", "uturn"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	genesectburn: {
		tier: "Uber",
		doublesTier: "(DOU)",
	},
	genesectchill: {
		tier: "Uber",
		doublesTier: "(DOU)",
	},
	genesectdouse: {
		tier: "Uber",
		doublesTier: "(DOU)",
	},
	genesectshock: {
		tier: "Uber",
		doublesTier: "(DOU)",
	},
	chespin: {
		tier: "LC",
	},
	quilladin: {
		tier: "NFE",
	},
	chesnaught: {
		randomBattleMoves: ["drainpunch", "leechseed", "spikes", "spikyshield", "synthesis", "woodhammer"],
		randomDoubleBattleMoves: ["hammerarm", "leechseed", "rockslide", "spikyshield", "stoneedge", "woodhammer"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	fennekin: {
		tier: "LC",
	},
	braixen: {
		tier: "NFE",
	},
	delphox: {
		randomBattleMoves: ["calmmind", "fireblast", "grassknot", "psyshock", "shadowball", "switcheroo"],
		randomDoubleBattleMoves: ["calmmind", "fireblast", "grassknot", "heatwave", "protect", "psyshock", "switcheroo"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	froakie: {
		tier: "LC",
	},
	frogadier: {
		tier: "NFE",
	},
	greninja: {
		randomBattleMoves: ["gunkshot", "hydropump", "icebeam", "spikes", "taunt", "toxicspikes", "uturn"],
		randomDoubleBattleMoves: ["darkpulse", "gunkshot", "hydropump", "icebeam", "matblock", "protect", "taunt", "uturn"],
		tier: "OU",
		doublesTier: "DUU",
	},
	greninjaash: {
		randomBattleMoves: ["darkpulse", "hydropump", "icebeam", "uturn", "watershuriken"],
		tier: "OU",
		doublesTier: "DUU",
	},
	bunnelby: {
		tier: "LC",
	},
	diggersby: {
		randomBattleMoves: ["agility", "earthquake", "knockoff", "quickattack", "return", "swordsdance", "uturn", "wildcharge"],
		randomDoubleBattleMoves: ["earthquake", "knockoff", "protect", "quickattack", "return", "uturn"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	fletchling: {
		tier: "LC",
	},
	fletchinder: {
		tier: "NFE",
	},
	talonflame: {
		randomBattleMoves: ["bravebird", "flareblitz", "overheat", "roost", "swordsdance", "uturn", "willowisp"],
		randomDoubleBattleMoves: ["bravebird", "flareblitz", "protect", "roost", "swordsdance", "tailwind", "taunt", "uturn", "willowisp"],
		tier: "RUBL",
		doublesTier: "DUU",
	},
	scatterbug: {
		tier: "LC",
	},
	spewpa: {
		tier: "NFE",
	},
	vivillon: {
		randomBattleMoves: ["energyball", "hurricane", "quiverdance", "sleeppowder", "substitute"],
		randomDoubleBattleMoves: ["bugbuzz", "hurricane", "protect", "quiverdance", "sleeppowder"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	vivillonfancy: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	vivillonpokeball: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	litleo: {
		tier: "LC",
	},
	pyroar: {
		randomBattleMoves: ["darkpulse", "fireblast", "hypervoice", "solarbeam", "sunnyday", "willowisp"],
		randomDoubleBattleMoves: ["fireblast", "hypervoice", "protect", "solarbeam", "sunnyday", "willowisp"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	flabebe: {
		tier: "LC",
	},
	floette: {
		tier: "NFE",
	},
	floetteeternal: {
		randomBattleMoves: ["hiddenpowerfire", "hiddenpowerground", "lightofruin", "moonblast", "psychic"],
		randomDoubleBattleMoves: ["calmmind", "dazzlinggleam", "hiddenpowerfire", "lightofruin", "protect", "psychic"],
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	florges: {
		randomBattleMoves: ["aromatherapy", "defog", "moonblast", "synthesis", "toxic", "wish"],
		randomDoubleBattleMoves: ["calmmind", "dazzlinggleam", "defog", "helpinghand", "moonblast", "protect", "psychic"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	skiddo: {
		tier: "LC",
	},
	gogoat: {
		randomBattleMoves: ["bulkup", "earthquake", "hornleech", "leechseed", "milkdrink", "rockslide", "substitute"],
		randomDoubleBattleMoves: ["brickbreak", "bulkup", "earthquake", "hornleech", "leechseed", "milkdrink", "protect", "rockslide"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pancham: {
		tier: "LC",
	},
	pangoro: {
		randomBattleMoves: ["bulletpunch", "drainpunch", "icepunch", "knockoff", "superpower", "swordsdance"],
		randomDoubleBattleMoves: ["gunkshot", "hammerarm", "icepunch", "knockoff", "partingshot", "protect"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	furfrou: {
		randomBattleMoves: ["cottonguard", "rest", "return", "substitute", "suckerpunch", "thunderwave", "toxic", "uturn"],
		randomDoubleBattleMoves: ["cottonguard", "protect", "return", "snarl", "thunderwave", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	espurr: {
		tier: "LC",
	},
	meowstic: {
		randomBattleMoves: ["healbell", "lightscreen", "psychic", "reflect", "thunderwave", "toxic", "yawn"],
		randomDoubleBattleMoves: ["fakeout", "lightscreen", "protect", "psychic", "reflect", "thunderwave"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	meowsticf: {
		randomBattleMoves: ["calmmind", "energyball", "psychic", "psyshock", "shadowball", "thunderbolt"],
		randomDoubleBattleMoves: ["darkpulse", "energyball", "fakeout", "helpinghand", "nastyplot", "protect", "psychic", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	honedge: {
		tier: "LC",
	},
	doublade: {
		randomBattleMoves: ["ironhead", "sacredsword", "shadowclaw", "shadowsneak", "swordsdance"],
		randomDoubleBattleMoves: ["ironhead", "protect", "sacredsword", "shadowclaw", "shadowsneak", "swordsdance"],
		tier: "UU",
		doublesTier: "NFE",
	},
	aegislash: {
		randomBattleMoves: ["flashcannon", "hiddenpowerice", "kingsshield", "shadowball", "shadowsneak", "toxic"],
		randomDoubleBattleMoves: ["flashcannon", "hiddenpowerice", "kingsshield", "shadowball", "shadowsneak"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	aegislashblade: {
		randomBattleMoves: ["ironhead", "sacredsword", "shadowclaw", "shadowsneak", "swordsdance"],
		randomDoubleBattleMoves: ["ironhead", "kingsshield", "sacredsword", "shadowclaw", "shadowsneak", "swordsdance"],
	},
	spritzee: {
		tier: "LC",
	},
	aromatisse: {
		randomBattleMoves: ["calmmind", "moonblast", "rest", "sleeptalk", "toxic"],
		randomDoubleBattleMoves: ["healpulse", "moonblast", "protect", "thunderbolt", "trickroom"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	swirlix: {
		tier: "NFE",
	},
	slurpuff: {
		randomBattleMoves: ["bellydrum", "drainpunch", "playrough", "return"],
		randomDoubleBattleMoves: ["bellydrum", "drainpunch", "playrough", "protect", "return"],
		tier: "NUBL",
		doublesTier: "(DUU)",
	},
	inkay: {
		tier: "LC",
	},
	malamar: {
		randomBattleMoves: ["happyhour", "knockoff", "psychocut", "rest", "sleeptalk", "superpower"],
		randomDoubleBattleMoves: ["knockoff", "protect", "psychocut", "rockslide", "superpower", "trickroom"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	binacle: {
		tier: "LC",
	},
	barbaracle: {
		randomBattleMoves: ["earthquake", "liquidation", "lowkick", "shellsmash", "stoneedge"],
		randomDoubleBattleMoves: ["crosschop", "liquidation", "protect", "rockslide", "shellsmash"],
		tier: "NUBL",
		doublesTier: "(DUU)",
	},
	skrelp: {
		tier: "LC",
	},
	dragalge: {
		randomBattleMoves: ["dracometeor", "dragonpulse", "focusblast", "hiddenpowerfire", "scald", "sludgewave", "toxicspikes"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "focusblast", "hiddenpowerfire", "protect", "scald", "sludgebomb"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	clauncher: {
		tier: "LC",
	},
	clawitzer: {
		randomBattleMoves: ["aurasphere", "darkpulse", "icebeam", "scald", "uturn", "waterpulse"],
		randomDoubleBattleMoves: ["aurasphere", "darkpulse", "helpinghand", "icebeam", "muddywater", "protect", "uturn", "waterpulse"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	helioptile: {
		tier: "LC",
	},
	heliolisk: {
		randomBattleMoves: ["darkpulse", "hiddenpowerice", "hypervoice", "raindance", "surf", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["darkpulse", "grassknot", "hypervoice", "protect", "thunderbolt", "voltswitch"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	tyrunt: {
		tier: "LC",
	},
	tyrantrum: {
		randomBattleMoves: ["dragonclaw", "dragondance", "earthquake", "headsmash", "outrage", "stealthrock", "superpower"],
		randomDoubleBattleMoves: ["dragonclaw", "dragondance", "earthquake", "headsmash", "protect", "rockslide"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	amaura: {
		tier: "LC",
	},
	aurorus: {
		randomBattleMoves: ["ancientpower", "blizzard", "earthpower", "freezedry", "hypervoice", "stealthrock", "thunderwave"],
		randomDoubleBattleMoves: ["ancientpower", "earthpower", "freezedry", "hypervoice", "icywind", "protect", "thunderwave"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	sylveon: {
		randomBattleMoves: ["calmmind", "hiddenpowerfire", "hypervoice", "protect", "psyshock", "wish"],
		randomDoubleBattleMoves: ["helpinghand", "hiddenpowerground", "hypervoice", "protect", "psyshock", "shadowball"],
		tier: "UU",
		doublesTier: "DUU",
	},
	hawlucha: {
		randomBattleMoves: ["acrobatics", "highjumpkick", "skyattack", "substitute", "swordsdance"],
		randomDoubleBattleMoves: ["acrobatics", "encore", "highjumpkick", "protect", "swordsdance"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	dedenne: {
		randomBattleMoves: ["protect", "recycle", "thunderbolt", "toxic"],
		randomDoubleBattleMoves: ["eerieimpulse", "helpinghand", "nuzzle", "recycle", "superfang", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	carbink: {
		randomBattleMoves: ["explosion", "lightscreen", "moonblast", "powergem", "reflect", "stealthrock"],
		randomDoubleBattleMoves: ["explosion", "lightscreen", "moonblast", "protect", "reflect", "stealthrock", "trickroom"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	goomy: {
		tier: "LC",
	},
	sliggoo: {
		tier: "NFE",
	},
	goodra: {
		randomBattleMoves: ["dracometeor", "dragontail", "earthquake", "fireblast", "powerwhip", "sludgebomb", "thunderbolt"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "fireblast", "muddywater", "powerwhip", "protect", "thunderbolt"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	klefki: {
		randomBattleMoves: ["dazzlinggleam", "foulplay", "magnetrise", "spikes", "thunderwave", "toxic"],
		randomDoubleBattleMoves: ["dazzlinggleam", "foulplay", "lightscreen", "playrough", "protect", "reflect", "thunderwave"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	phantump: {
		tier: "LC",
	},
	trevenant: {
		randomBattleMoves: ["earthquake", "hornleech", "rockslide", "shadowclaw", "trickroom", "woodhammer"],
		randomDoubleBattleMoves: ["hornleech", "leechseed", "protect", "rockslide", "shadowclaw", "trickroom", "willowisp", "woodhammer"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pumpkaboo: {
		tier: "LC",
	},
	pumpkaboosmall: {
		tier: "LC",
	},
	pumpkaboolarge: {
		tier: "LC",
	},
	pumpkaboosuper: {
		tier: "LC",
	},
	gourgeist: {
		randomBattleMoves: ["leechseed", "seedbomb", "shadowsneak", "substitute", "synthesis", "willowisp"],
		randomDoubleBattleMoves: ["leechseed", "phantomforce", "protect", "seedbomb", "shadowsneak", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gourgeistsmall: {
		randomBattleMoves: ["leechseed", "seedbomb", "shadowsneak", "substitute", "synthesis", "willowisp"],
		randomDoubleBattleMoves: ["leechseed", "phantomforce", "protect", "seedbomb", "shadowsneak", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gourgeistlarge: {
		randomBattleMoves: ["leechseed", "seedbomb", "shadowsneak", "substitute", "synthesis", "willowisp"],
		randomDoubleBattleMoves: ["leechseed", "phantomforce", "protect", "seedbomb", "shadowsneak", "trickroom", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gourgeistsuper: {
		randomBattleMoves: ["leechseed", "seedbomb", "shadowsneak", "substitute", "synthesis", "willowisp"],
		randomDoubleBattleMoves: ["leechseed", "phantomforce", "protect", "seedbomb", "shadowsneak", "trickroom", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	bergmite: {
		tier: "LC",
	},
	avalugg: {
		randomBattleMoves: ["avalanche", "earthquake", "rapidspin", "recover", "roar", "toxic"],
		randomDoubleBattleMoves: ["avalanche", "earthquake", "protect", "recover"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	noibat: {
		tier: "LC",
	},
	noivern: {
		randomBattleMoves: ["boomburst", "dracometeor", "flamethrower", "hurricane", "roost", "switcheroo", "taunt", "uturn"],
		randomDoubleBattleMoves: ["dracometeor", "flamethrower", "hurricane", "protect", "switcheroo", "tailwind", "taunt", "uturn"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	xerneas: {
		randomBattleMoves: ["focusblast", "geomancy", "hiddenpowerfire", "moonblast", "psyshock", "thunderbolt"],
		randomDoubleBattleMoves: ["closecombat", "dazzlinggleam", "focusblast", "geomancy", "hiddenpowerfire", "protect", "psyshock", "rockslide", "thunderbolt"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	yveltal: {
		randomBattleMoves: ["darkpulse", "focusblast", "foulplay", "oblivionwing", "roost", "suckerpunch", "taunt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["darkpulse", "heatwave", "oblivionwing", "protect", "roost", "skydrop", "snarl", "suckerpunch", "taunt"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	zygarde: {
		randomBattleMoves: ["dragondance", "extremespeed", "outrage", "substitute", "thousandarrows"],
		randomDoubleBattleMoves: ["coil", "dragondance", "extremespeed", "glare", "protect", "rockslide", "stoneedge", "thousandarrows"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	zygarde10: {
		randomBattleMoves: ["coil", "extremespeed", "irontail", "outrage", "thousandarrows"],
		randomDoubleBattleMoves: ["dragondance", "extremespeed", "irontail", "protect", "thousandarrows"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	zygardecomplete: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	diancie: {
		randomBattleMoves: ["diamondstorm", "earthpower", "lightscreen", "moonblast", "reflect", "stealthrock"],
		randomDoubleBattleMoves: ["calmmind", "dazzlinggleam", "diamondstorm", "earthpower", "moonblast", "protect"],
		tier: "RU",
		doublesTier: "DOU",
	},
	dianciemega: {
		randomBattleMoves: ["calmmind", "diamondstorm", "earthpower", "hiddenpowerfire", "moonblast"],
		randomDoubleBattleMoves: ["calmmind", "dazzlinggleam", "diamondstorm", "earthpower", "hiddenpowerfire", "moonblast", "protect", "psyshock"],
		tier: "OU",
		doublesTier: "DOU",
	},
	hoopa: {
		randomBattleMoves: ["focusblast", "nastyplot", "psyshock", "shadowball", "trick"],
		randomDoubleBattleMoves: ["focusblast", "hyperspacehole", "protect", "shadowball", "trickroom"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	hoopaunbound: {
		randomBattleMoves: ["darkpulse", "drainpunch", "focusblast", "gunkshot", "hyperspacefury", "icepunch", "nastyplot", "psychic", "substitute", "trick", "zenheadbutt"],
		randomDoubleBattleMoves: ["darkpulse", "drainpunch", "focusblast", "gunkshot", "hyperspacefury", "icepunch", "protect", "psychic", "zenheadbutt"],
		tier: "UUBL",
		doublesTier: "DOU",
	},
	volcanion: {
		randomBattleMoves: ["earthpower", "fireblast", "sludgebomb", "steameruption", "substitute", "superpower"],
		randomDoubleBattleMoves: ["earthpower", "heatwave", "protect", "sludgebomb", "steameruption"],
		tier: "UU",
		doublesTier: "DOU",
	},
	rowlet: {
		tier: "LC",
	},
	dartrix: {
		tier: "NFE",
	},
	decidueye: {
		randomBattleMoves: ["leafblade", "roost", "shadowsneak", "spiritshackle", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["bravebird", "leafblade", "protect", "spiritshackle", "suckerpunch"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	litten: {
		tier: "LC",
	},
	torracat: {
		tier: "NFE",
	},
	incineroar: {
		randomBattleMoves: ["darkestlariat", "earthquake", "fakeout", "flareblitz", "knockoff", "uturn"],
		randomDoubleBattleMoves: ["fakeout", "flareblitz", "knockoff", "snarl", "taunt", "uturn", "willowisp"],
		tier: "NU",
		doublesTier: "DOU",
	},
	popplio: {
		tier: "LC",
	},
	brionne: {
		tier: "NFE",
	},
	primarina: {
		randomBattleMoves: ["energyball", "hiddenpowerfire", "hydropump", "moonblast", "psychic", "scald"],
		randomDoubleBattleMoves: ["hypervoice", "icebeam", "moonblast", "protect", "psychic"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	pikipek: {
		tier: "LC",
	},
	trumbeak: {
		tier: "NFE",
	},
	toucannon: {
		randomBattleMoves: ["beakblast", "boomburst", "brickbreak", "bulletseed", "roost"],
		randomDoubleBattleMoves: ["beakblast", "bulletseed", "protect", "rockblast", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	yungoos: {
		tier: "LC",
	},
	gumshoos: {
		randomBattleMoves: ["crunch", "earthquake", "firepunch", "return", "uturn"],
		randomDoubleBattleMoves: ["crunch", "protect", "return", "superfang", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gumshoostotem: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	grubbin: {
		tier: "LC",
	},
	charjabug: {
		tier: "NFE",
	},
	vikavolt: {
		randomBattleMoves: ["agility", "bugbuzz", "energyball", "hiddenpowerice", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["bugbuzz", "hiddenpowerice", "protect", "stringshot", "thunderbolt", "voltswitch"],
		tier: "NU",
		doublesTier: "DUU",
	},
	vikavolttotem: {
		tier: "NU",
		doublesTier: "DUU",
	},
	crabrawler: {
		tier: "LC",
	},
	crabominable: {
		randomBattleMoves: ["closecombat", "earthquake", "icehammer", "stoneedge"],
		randomDoubleBattleMoves: ["closecombat", "earthquake", "icehammer", "protect", "stoneedge", "wideguard"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	oricorio: {
		randomBattleMoves: ["calmmind", "hurricane", "revelationdance", "roost", "toxic", "uturn"],
		randomDoubleBattleMoves: ["airslash", "hurricane", "protect", "revelationdance", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	oricoriopompom: {
		randomBattleMoves: ["calmmind", "hurricane", "revelationdance", "roost", "toxic", "uturn"],
		randomDoubleBattleMoves: ["airslash", "hurricane", "protect", "revelationdance", "tailwind"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	oricoriopau: {
		randomBattleMoves: ["calmmind", "hurricane", "revelationdance", "roost", "toxic", "uturn"],
		randomDoubleBattleMoves: ["airslash", "hurricane", "protect", "revelationdance", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	oricoriosensu: {
		randomBattleMoves: ["calmmind", "hurricane", "revelationdance", "roost", "toxic", "uturn"],
		randomDoubleBattleMoves: ["airslash", "hurricane", "protect", "revelationdance", "tailwind"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	cutiefly: {
		tier: "NFE",
	},
	ribombee: {
		randomBattleMoves: ["bugbuzz", "hiddenpowerfire", "moonblast", "quiverdance", "roost", "stickyweb"],
		randomDoubleBattleMoves: ["moonblast", "pollenpuff", "protect", "quiverdance", "stickyweb"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	ribombeetotem: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	rockruff: {
		tier: "LC",
	},
	rockruffdusk: {
		tier: "LC",
	},
	lycanroc: {
		randomBattleMoves: ["accelerock", "drillrun", "firefang", "stoneedge", "swordsdance"],
		randomDoubleBattleMoves: ["accelerock", "crunch", "firefang", "protect", "stoneedge", "taunt"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	lycanrocmidnight: {
		randomBattleMoves: ["firepunch", "stealthrock", "stoneedge", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["protect", "stoneedge", "suckerpunch", "swordsdance", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	lycanrocdusk: {
		randomBattleMoves: ["accelerock", "drillrun", "firefang", "return", "stoneedge", "swordsdance"],
		randomDoubleBattleMoves: ["accelerock", "drillrun", "firefang", "protect", "rockslide", "stoneedge"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	wishiwashi: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	wishiwashischool: {
		randomBattleMoves: ["earthquake", "hiddenpowergrass", "hydropump", "icebeam", "scald"],
		randomDoubleBattleMoves: ["earthquake", "endeavor", "helpinghand", "hiddenpowergrass", "hydropump", "icebeam", "protect"],
	},
	mareanie: {
		tier: "LC",
	},
	toxapex: {
		randomBattleMoves: ["banefulbunker", "haze", "recover", "scald", "toxicspikes"],
		randomDoubleBattleMoves: ["banefulbunker", "haze", "recover", "scald", "toxicspikes", "wideguard"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	mudbray: {
		tier: "LC",
	},
	mudsdale: {
		randomBattleMoves: ["closecombat", "earthquake", "heavyslam", "rockslide", "stealthrock"],
		randomDoubleBattleMoves: ["closecombat", "heavyslam", "highhorsepower", "protect", "rockslide"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	dewpider: {
		tier: "LC",
	},
	araquanid: {
		randomBattleMoves: ["liquidation", "lunge", "mirrorcoat", "stickyweb", "toxic"],
		randomDoubleBattleMoves: ["liquidation", "lunge", "protect", "stickyweb", "wideguard"],
		tier: "RU",
		doublesTier: "DUU",
	},
	araquanidtotem: {
		tier: "RU",
		doublesTier: "DUU",
	},
	fomantis: {
		tier: "LC",
	},
	lurantis: {
		randomBattleMoves: ["hiddenpowerice", "knockoff", "leafstorm", "superpower", "synthesis"],
		randomDoubleBattleMoves: ["hiddenpowerice", "knockoff", "leafstorm", "protect", "superpower"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	lurantistotem: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	morelull: {
		tier: "LC",
	},
	shiinotic: {
		randomBattleMoves: ["gigadrain", "leechseed", "moonblast", "spore", "strengthsap"],
		randomDoubleBattleMoves: ["gigadrain", "leechseed", "moonblast", "protect", "spore", "strengthsap"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	salandit: {
		tier: "LC",
	},
	salazzle: {
		randomBattleMoves: ["fireblast", "hiddenpowergrass", "nastyplot", "sludgewave"],
		randomDoubleBattleMoves: ["encore", "fakeout", "flamethrower", "hiddenpowergrass", "hiddenpowerground", "protect", "sludgebomb", "taunt"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	salazzletotem: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	stufful: {
		tier: "LC",
	},
	bewear: {
		randomBattleMoves: ["doubleedge", "hammerarm", "icepunch", "return", "shadowclaw", "swordsdance"],
		randomDoubleBattleMoves: ["doubleedge", "hammerarm", "icepunch", "protect", "wideguard"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	bounsweet: {
		tier: "LC",
	},
	steenee: {
		tier: "NFE",
	},
	tsareena: {
		randomBattleMoves: ["highjumpkick", "knockoff", "powerwhip", "rapidspin", "synthesis", "uturn"],
		randomDoubleBattleMoves: ["feint", "knockoff", "playrough", "powerwhip", "protect", "uturn"],
		tier: "RU",
		doublesTier: "DUU",
	},
	comfey: {
		randomBattleMoves: ["aromatherapy", "drainingkiss", "synthesis", "toxic", "uturn"],
		randomDoubleBattleMoves: ["drainingkiss", "floralhealing", "taunt", "toxic", "uturn"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	oranguru: {
		randomBattleMoves: ["focusblast", "nastyplot", "psyshock", "thunderbolt", "trickroom"],
		randomDoubleBattleMoves: ["foulplay", "instruct", "protect", "psychic", "trickroom"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	passimian: {
		randomBattleMoves: ["closecombat", "earthquake", "gunkshot", "knockoff", "rockslide", "uturn"],
		randomDoubleBattleMoves: ["closecombat", "knockoff", "protect", "rockslide", "taunt", "uturn"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	wimpod: {
		tier: "LC",
	},
	golisopod: {
		randomBattleMoves: ["aquajet", "firstimpression", "knockoff", "liquidation", "spikes"],
		randomDoubleBattleMoves: ["aquajet", "firstimpression", "leechlife", "liquidation", "protect", "wideguard"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	sandygast: {
		tier: "LC",
	},
	palossand: {
		randomBattleMoves: ["earthpower", "shadowball", "shoreup", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthpower", "protect", "shadowball", "shoreup", "stealthrock", "toxic"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	pyukumuku: {
		randomBattleMoves: ["block", "recover", "soak", "toxic"],
		randomDoubleBattleMoves: ["counter", "helpinghand", "lightscreen", "memento", "reflect"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	typenull: {
		randomBattleMoves: ["rest", "return", "sleeptalk", "swordsdance", "uturn"],
		tier: "(PU)",
		doublesTier: "NFE",
	},
	silvally: {
		randomBattleMoves: ["crunch", "doubleedge", "flamecharge", "flamethrower", "icebeam", "ironhead", "return", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["crunch", "doubleedge", "explosion", "flamecharge", "icebeam", "partingshot", "protect", "swordsdance", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallybug: {
		randomBattleMoves: ["defog", "flamethrower", "icebeam", "thunderbolt", "uturn"],
		randomDoubleBattleMoves: ["flamethrower", "icebeam", "protect", "thunderbolt", "thunderwave", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallydark: {
		randomBattleMoves: ["flamecharge", "ironhead", "multiattack", "swordsdance"],
		randomDoubleBattleMoves: ["icebeam", "multiattack", "partingshot", "protect", "snarl", "thunderwave", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallydragon: {
		randomBattleMoves: ["dracometeor", "flamecharge", "flamethrower", "icebeam", "ironhead", "multiattack", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["flamethrower", "icebeam", "multiattack", "partingshot", "protect", "thunderwave", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyelectric: {
		randomBattleMoves: ["flamethrower", "icebeam", "multiattack", "partingshot", "toxic"],
		randomDoubleBattleMoves: ["icebeam", "partingshot", "protect", "snarl", "thunderbolt", "thunderwave", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyfairy: {
		randomBattleMoves: ["flamethrower", "multiattack", "partingshot", "rockslide", "thunderwave"],
		randomDoubleBattleMoves: ["flamethrower", "icebeam", "multiattack", "partingshot", "protect", "thunderwave", "uturn"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	silvallyfighting: {
		randomBattleMoves: ["flamecharge", "ironhead", "multiattack", "shadowclaw", "swordsdance"],
		randomDoubleBattleMoves: ["flamecharge", "multiattack", "protect", "rockslide", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyfire: {
		randomBattleMoves: ["defog", "icebeam", "multiattack", "thunderbolt", "uturn"],
		randomDoubleBattleMoves: ["flamethrower", "icebeam", "protect", "snarl", "thunderbolt", "thunderwave", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyflying: {
		randomBattleMoves: ["flamethrower", "ironhead", "multiattack", "partingshot", "thunderwave"],
		randomDoubleBattleMoves: ["flamecharge", "ironhead", "multiattack", "partingshot", "protect", "swordsdance", "thunderwave", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyghost: {
		randomBattleMoves: ["flamethrower", "icebeam", "multiattack", "partingshot", "toxic"],
		randomDoubleBattleMoves: ["icebeam", "multiattack", "partingshot", "protect", "uturn"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	silvallygrass: {
		randomBattleMoves: ["flamethrower", "icebeam", "multiattack", "partingshot", "toxic"],
		randomDoubleBattleMoves: ["flamethrower", "icebeam", "multiattack", "partingshot", "protect", "thunderwave", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyground: {
		randomBattleMoves: ["flamecharge", "multiattack", "rockslide", "swordsdance"],
		randomDoubleBattleMoves: ["flamecharge", "icebeam", "multiattack", "protect", "rockslide", "swordsdance", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyice: {
		randomBattleMoves: ["flamethrower", "multiattack", "thunderbolt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["icebeam", "partingshot", "protect", "thunderbolt", "thunderwave", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallypoison: {
		randomBattleMoves: ["flamethrower", "icebeam", "multiattack", "partingshot", "toxic"],
		randomDoubleBattleMoves: ["flamethrower", "icebeam", "multiattack", "partingshot", "protect", "thunderwave", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallypsychic: {
		randomBattleMoves: ["flamethrower", "multiattack", "partingshot", "rockslide", "thunderwave"],
		randomDoubleBattleMoves: ["flamethrower", "multiattack", "partingshot", "protect", "thunderwave", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallyrock: {
		randomBattleMoves: ["flamethrower", "grasspledge", "multiattack", "partingshot", "toxic"],
		randomDoubleBattleMoves: ["flamethrower", "icebeam", "partingshot", "protect", "rockslide", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	silvallysteel: {
		randomBattleMoves: ["crunch", "defog", "flamethrower", "multiattack", "thunderbolt"],
		randomDoubleBattleMoves: ["flamecharge", "multiattack", "partingshot", "protect", "rockslide", "swordsdance", "uturn"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	silvallywater: {
		randomBattleMoves: ["defog", "icebeam", "multiattack", "partingshot", "thunderbolt"],
		randomDoubleBattleMoves: ["flamethrower", "icebeam", "multiattack", "partingshot", "protect", "thunderbolt", "thunderwave", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	minior: {
		randomBattleMoves: ["acrobatics", "earthquake", "powergem", "shellsmash"],
		randomDoubleBattleMoves: ["acrobatics", "earthquake", "powergem", "protect", "shellsmash"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	miniormeteor: {},
	komala: {
		randomBattleMoves: ["earthquake", "playrough", "return", "suckerpunch", "uturn", "woodhammer"],
		randomDoubleBattleMoves: ["playrough", "protect", "return", "shadowclaw", "suckerpunch", "swordsdance", "uturn", "woodhammer"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	turtonator: {
		randomBattleMoves: ["dracometeor", "dragonpulse", "dragontail", "earthquake", "explosion", "fireblast", "shellsmash"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "fireblast", "protect", "shellsmash"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	togedemaru: {
		randomBattleMoves: ["ironhead", "nuzzle", "spikyshield", "uturn", "wish", "zingzap"],
		randomDoubleBattleMoves: ["encore", "fakeout", "ironhead", "nuzzle", "spikyshield", "uturn", "zingzap"],
		tier: "NU",
		doublesTier: "DUU",
	},
	togedemarutotem: {
		tier: "NU",
		doublesTier: "DUU",
	},
	mimikyu: {
		randomBattleMoves: ["playrough", "shadowclaw", "shadowsneak", "swordsdance", "taunt"],
		randomDoubleBattleMoves: ["playrough", "protect", "shadowclaw", "shadowsneak", "swordsdance", "willowisp"],
		tier: "UU",
		doublesTier: "DUU",
	},
	mimikyutotem: {
		tier: "UU",
		doublesTier: "DUU",
	},
	mimikyubustedtotem: {},
	bruxish: {
		randomBattleMoves: ["aquajet", "crunch", "icefang", "liquidation", "psychicfangs", "swordsdance"],
		randomDoubleBattleMoves: ["aquajet", "crunch", "liquidation", "protect", "psychicfangs", "swordsdance"],
		tier: "NUBL",
		doublesTier: "DUU",
	},
	drampa: {
		randomBattleMoves: ["dracometeor", "dragonpulse", "fireblast", "glare", "hypervoice", "roost", "thunderbolt"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "fireblast", "glare", "hypervoice", "protect", "roost"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	dhelmise: {
		randomBattleMoves: ["anchorshot", "earthquake", "knockoff", "powerwhip", "rapidspin", "synthesis"],
		randomDoubleBattleMoves: ["anchorshot", "knockoff", "powerwhip", "protect", "rapidspin"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	jangmoo: {
		tier: "LC",
	},
	hakamoo: {
		tier: "NFE",
	},
	kommoo: {
		randomBattleMoves: ["clangingscales", "closecombat", "dragondance", "outrage", "poisonjab"],
		randomDoubleBattleMoves: ["clangingscales", "closecombat", "dragondance", "poisonjab"],
		tier: "OU",
		doublesTier: "DOU",
	},
	kommoototem: {
		tier: "OU",
		doublesTier: "DOU",
	},
	tapukoko: {
		randomBattleMoves: ["bravebird", "dazzlinggleam", "defog", "naturesmadness", "thunderbolt", "uturn"],
		randomDoubleBattleMoves: ["dazzlinggleam", "hiddenpowerice", "naturesmadness", "protect", "skydrop", "taunt", "thunderbolt", "uturn"],
		tier: "OU",
		doublesTier: "DOU",
	},
	tapulele: {
		randomBattleMoves: ["calmmind", "focusblast", "hiddenpowerfire", "moonblast", "psychic", "psyshock"],
		randomDoubleBattleMoves: ["dazzlinggleam", "focusblast", "moonblast", "protect", "psychic", "taunt"],
		tier: "OU",
		doublesTier: "DOU",
	},
	tapubulu: {
		randomBattleMoves: ["bulkup", "hornleech", "megahorn", "stoneedge", "superpower", "woodhammer"],
		randomDoubleBattleMoves: ["hornleech", "naturesmadness", "protect", "stoneedge", "superpower", "woodhammer"],
		tier: "OU",
		doublesTier: "DOU",
	},
	tapufini: {
		randomBattleMoves: ["calmmind", "hydropump", "icebeam", "moonblast", "scald", "taunt"],
		randomDoubleBattleMoves: ["healpulse", "moonblast", "muddywater", "naturesmadness", "protect", "swagger", "taunt"],
		tier: "OU",
		doublesTier: "DOU",
	},
	cosmog: {
		tier: "LC",
	},
	cosmoem: {
		tier: "NFE",
	},
	solgaleo: {
		randomBattleMoves: ["earthquake", "flareblitz", "morningsun", "stoneedge", "sunsteelstrike", "zenheadbutt"],
		randomDoubleBattleMoves: ["flareblitz", "morningsun", "protect", "sunsteelstrike", "wideguard", "zenheadbutt"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	lunala: {
		randomBattleMoves: ["calmmind", "focusblast", "moonblast", "moongeistbeam", "psyshock", "roost"],
		randomDoubleBattleMoves: ["moonblast", "moongeistbeam", "protect", "psychic", "roost", "wideguard"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	nihilego: {
		randomBattleMoves: ["grassknot", "powergem", "sludgewave", "stealthrock", "thunderbolt", "toxicspikes"],
		randomDoubleBattleMoves: ["grassknot", "hiddenpowerice", "powergem", "protect", "sludgebomb", "thunderbolt"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	buzzwole: {
		randomBattleMoves: ["drainpunch", "earthquake", "leechlife", "poisonjab", "stoneedge", "superpower"],
		randomDoubleBattleMoves: ["drainpunch", "icepunch", "leechlife", "poisonjab", "protect", "superpower"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	pheromosa: {
		randomBattleMoves: ["highjumpkick", "icebeam", "poisonjab", "throatchop", "uturn"],
		randomDoubleBattleMoves: ["bugbuzz", "highjumpkick", "icebeam", "poisonjab", "protect", "speedswap", "uturn"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	xurkitree: {
		randomBattleMoves: ["dazzlinggleam", "electricterrain", "energyball", "hiddenpowerice", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["energyball", "hiddenpowerice", "hypnosis", "protect", "tailglow", "thunderbolt"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	celesteela: {
		randomBattleMoves: ["airslash", "autotomize", "earthquake", "fireblast", "heavyslam", "leechseed", "protect"],
		randomDoubleBattleMoves: ["earthquake", "fireblast", "heavyslam", "leechseed", "protect", "wideguard"],
		tier: "OU",
		doublesTier: "DOU",
	},
	kartana: {
		randomBattleMoves: ["knockoff", "leafblade", "sacredsword", "smartstrike", "swordsdance"],
		randomDoubleBattleMoves: ["knockoff", "leafblade", "protect", "sacredsword", "smartstrike", "swordsdance"],
		tier: "OU",
		doublesTier: "DOU",
	},
	guzzlord: {
		randomBattleMoves: ["dracometeor", "earthquake", "fireblast", "heavyslam", "knockoff"],
		randomDoubleBattleMoves: ["dracometeor", "fireblast", "knockoff", "protect", "wideguard"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	necrozma: {
		randomBattleMoves: ["calmmind", "heatwave", "moonlight", "photongeyser", "stealthrock"],
		randomDoubleBattleMoves: ["calmmind", "earthpower", "heatwave", "moonlight", "photongeyser"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	necrozmaduskmane: {
		randomBattleMoves: ["autotomize", "earthquake", "knockoff", "photongeyser", "sunsteelstrike", "swordsdance"],
		randomDoubleBattleMoves: ["earthquake", "knockoff", "photongeyser", "rockslide", "sunsteelstrike", "swordsdance"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	necrozmadawnwings: {
		randomBattleMoves: ["calmmind", "heatwave", "moongeistbeam", "photongeyser", "powergem", "trickroom"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	necrozmaultra: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	magearna: {
		randomBattleMoves: ["calmmind", "flashcannon", "fleurcannon", "focusblast", "ironhead", "shiftgear", "thunderbolt"],
		randomDoubleBattleMoves: ["aurasphere", "dazzlinggleam", "flashcannon", "fleurcannon", "protect", "trickroom", "voltswitch"],
		tier: "OU",
		doublesTier: "DUber",
	},
	magearnaoriginal: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	marshadow: {
		randomBattleMoves: ["bulkup", "closecombat", "icepunch", "rocktomb", "shadowsneak", "spectralthief"],
		randomDoubleBattleMoves: ["bulkup", "closecombat", "icepunch", "protect", "shadowsneak", "spectralthief"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	poipole: {
		tier: "NFE",
	},
	naganadel: {
		randomBattleMoves: ["dracometeor", "dragonpulse", "fireblast", "nastyplot", "sludgewave", "uturn"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "fireblast", "protect", "sludgebomb", "tailwind", "uturn"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	stakataka: {
		randomBattleMoves: ["earthquake", "gyroball", "stealthrock", "stoneedge", "superpower", "trickroom"],
		randomDoubleBattleMoves: ["earthquake", "gyroball", "rockslide", "stealthrock", "stoneedge", "superpower", "trickroom"],
		tier: "RUBL",
		doublesTier: "DOU",
	},
	blacephalon: {
		randomBattleMoves: ["calmmind", "explosion", "fireblast", "hiddenpowerice", "shadowball", "trick"],
		randomDoubleBattleMoves: ["fireblast", "heatwave", "hiddenpowerice", "protect", "shadowball", "willowisp"],
		tier: "OU",
		doublesTier: "DUU",
	},
	zeraora: {
		randomBattleMoves: ["closecombat", "grassknot", "hiddenpowerice", "knockoff", "plasmafists", "voltswitch", "workup"],
		randomDoubleBattleMoves: ["closecombat", "fakeout", "grassknot", "hiddenpowerice", "knockoff", "plasmafists", "protect", "voltswitch"],
		tier: "UU",
		doublesTier: "DOU",
	},
	meltan: {
		isNonstandard: "LGPE",
		tier: "Illegal",
	},
	melmetal: {
		isNonstandard: "LGPE",
		tier: "Illegal",
	},
};
